(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[38252,62788],{

/***/ 49586:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/payment",
      function () {
        return __webpack_require__(61529);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 88737:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(75154);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(22318);



function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(function(theme) {
    var _obj;
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        root: (_obj = {
            display: 'flex',
            flexWrap: 'wrap',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center',
            minHeight: 70,
            padding: theme.spacing(4, 2),
            borderRadius: 6,
            background: theme.palette.primaryTransparent.light
        }, _defineProperty(_obj, theme.breakpoints.up('lg'), {
            flexDirection: 'row',
            justifyContent: 'space-between',
            textAlign: 'left',
            minHeight: 100,
            height: '100%',
            padding: theme.spacing(4, 4),
            borderRadius: theme.shape.borderRadius
        }), _defineProperty(_obj, '.MuiGrid-grid-md-4 &', {
            height: 'auto',
            padding: theme.spacing(1, 2),
            margin: theme.spacing(2, 0, 3)
        }), _obj),
        media: _defineProperty({
            margin: theme.spacing(0, 0, 2),
            '&>img': {
                display: 'block',
                maxWidth: 60
            }
        }, theme.breakpoints.up('lg'), {
            margin: 0,
            paddingRight: theme.spacing(5),
            '&>img': {
                maxWidth: 60
            }
        }),
        text: {
            flex: 1
        },
        richText: {
            '& p, & ul, & ol': {
                margin: 0
            },
            '& a': {
                color: 'currentColor',
                textDecoration: 'underline',
                '&:hover, &:focus': {
                    textDecoration: 'none'
                }
            }
        },
        rootCenter: _defineProperty({}, theme.breakpoints.up('lg'), {
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            textAlign: 'center'
        }),
        mediaCenter: {
            margin: theme.spacing(0, 0, 2),
            paddingRight: 0
        },
        commitmentImage: {
            width: '60px'
        }
    });
});
var Commitment = function(props) {
    var classes = useStyles(props);
    var icon = props.icon, title = props.title, desc = props.desc, center = props.center;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: center ? "commitment ".concat(classes.rootCenter, " ").concat(classes.root) : "commitment ".concat(classes.root),
        children: [
            icon && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: center ? "commitment__media ".concat(classes.mediaCenter, " ").concat(classes.media) : "commitment__media ".concat(classes.media),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                    src: icon,
                    alt: "",
                    className: classes.commitmentImage
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "commitment__text ".concat(classes.text),
                children: [
                    title && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        variant: "h3",
                        component: "p",
                        className: 'commitment__title',
                        children: title
                    }),
                    desc && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                        variant: "body1",
                        component: "div",
                        className: "commitment__desc ".concat(classes.richText),
                        children: desc
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Commitment);


/***/ }),

/***/ 62788:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_script__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(4298);
/* harmony import */ var _CMSText__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(94455);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* provided dependency */ var process = __webpack_require__(34155);






var SharedHead = function(param) {
    var datas = param.datas;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var favicon = (datas === null || datas === void 0 ? void 0 : (ref = datas.data) === null || ref === void 0 ? void 0 : ref.favicon) ? datas.data.favicon : null;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();
    var pageRoute = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(function() {
        var basePath = 'https://' + (process.env.PUBLIC_DOMAIN || ( true ? window.location.host : 0));
        var locale = router.locale === router.defaultLocale ? '' : "/".concat(router.locale);
        var href = "".concat(basePath).concat(locale).concat(router.asPath);
        return href.endsWith('/') ? href.slice(0, -1) : href;
    }, [
        router.asPath,
        router.pathname,
        router.isReady
    ]);
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_2__["default"], {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1, maximum-scale=1"
            }),
            (datas === null || datas === void 0 ? void 0 : (ref1 = datas.data) === null || ref1 === void 0 ? void 0 : ref1.meta_url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: (0,_CMSText__WEBPACK_IMPORTED_MODULE_4__/* .prismicText */ .yz)(datas === null || datas === void 0 ? void 0 : (ref2 = datas.data) === null || ref2 === void 0 ? void 0 : ref2.meta_url)
            }),
            (datas === null || datas === void 0 ? void 0 : (ref3 = datas.data) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.meta_image) === null || ref4 === void 0 ? void 0 : ref4.url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: datas === null || datas === void 0 ? void 0 : (ref5 = datas.data) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.meta_image) === null || ref6 === void 0 ? void 0 : ref6.url,
                name: "image"
            }),
            process.env.NO_INDEX === undefined && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: pageRoute
            }, "canonical"),
            (favicon === null || favicon === void 0 ? void 0 : favicon.url) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "apple-touch-icon",
                        sizes: "180x180",
                        href: favicon.url
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                        rel: "icon",
                        type: "image/png",
                        sizes: "16x16 32x32 48x48",
                        href: favicon['small'].url
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(next_script__WEBPACK_IMPORTED_MODULE_3__["default"], {
                src: "https://unpkg.com/swiper@6.4.8/swiper-bundle.min.js"
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["default"] = (SharedHead);


/***/ }),

/***/ 8122:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _Header__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(49841);
/* harmony import */ var _Footer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(79956);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var clsx__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(86010);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var _utils_scrollState__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75216);
/* harmony import */ var _Global_SharedHead__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(62788);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94455);









var Layout = function(param) {
    var children = param.children, doc = param.doc, account = param.account, faq = param.faq, hideTop = param.hideTop, mainLogo = param.mainLogo, headerTitle = param.headerTitle, t = param.t, inStoreText = param.inStoreText, banner = param.banner, metaTitle = param.metaTitle, metaDescription = param.metaDescription, metaKeywords = param.metaKeywords, metaDescriptionProduct = param.metaDescriptionProduct, metaKeywordsProduct = param.metaKeywordsProduct, metaImage = param.metaImage, pageType = param.pageType, takeback = param.takeback, basket = param.basket, pageName = param.pageName;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11;
    var scrollState = (0,_utils_scrollState__WEBPACK_IMPORTED_MODULE_5__/* .useScrollState */ .M)();
    var isBanner = (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .isPrismicText */ .LT)(banner === null || banner === void 0 ? void 0 : (ref = banner.data) === null || ref === void 0 ? void 0 : ref.text);
    var isDisplayedBannerOnAllPages = banner === null || banner === void 0 ? void 0 : (ref1 = banner.data) === null || ref1 === void 0 ? void 0 : ref1.is_displayed_banner_on_all_pages;
    var metaTitleString = metaTitle && (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .isPrismicText */ .LT)(doc === null || doc === void 0 ? void 0 : (ref2 = doc.data) === null || ref2 === void 0 ? void 0 : ref2.baseline) ? "".concat((0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .prismicText */ .yz)(doc === null || doc === void 0 ? void 0 : (ref3 = doc.data) === null || ref3 === void 0 ? void 0 : ref3.baseline), " - ").concat(metaTitle) : metaTitle;
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (0,clsx__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)('page', pageType && "page--".concat(pageType)),
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_SharedHead__WEBPACK_IMPORTED_MODULE_6__["default"], {
                datas: doc
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(next_head__WEBPACK_IMPORTED_MODULE_4__["default"], {
                children: [
                    metaTitleString && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                                children: metaTitleString
                            }, "pageTitle"),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:title",
                                name: "title",
                                content: metaTitleString
                            })
                        ]
                    }),
                    metaDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        name: "description",
                        content: metaDescription
                    }),
                    (metaKeywords === null || metaKeywords === void 0 ? void 0 : metaKeywords.length) && ((ref4 = metaKeywords[0]) === null || ref4 === void 0 ? void 0 : ref4.text) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:keywords",
                        name: "keywords",
                        content: (0,_Global_CMSText__WEBPACK_IMPORTED_MODULE_7__/* .prismicText */ .yz)(metaKeywords)
                    }),
                    metaKeywordsProduct && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:keywords",
                        name: "keywords",
                        content: metaKeywordsProduct
                    }),
                    metaDescriptionProduct && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                        property: "og:description",
                        name: "description",
                        content: metaDescriptionProduct
                    }),
                    metaImage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                property: "og:image",
                                content: metaImage
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                                name: "twitter:image",
                                content: metaImage
                            })
                        ]
                    })
                ]
            }),
            !(doc === null || doc === void 0 ? void 0 : (ref5 = doc.data) === null || ref5 === void 0 ? void 0 : ref5.hide_header) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Header__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                logo: mainLogo,
                t: t,
                title: headerTitle,
                inStoreText: inStoreText,
                doc: doc,
                account: account,
                faq: faq,
                showOnScrollUp: scrollState.showOnScrollUp,
                showOnTop: scrollState.showOnTop,
                textColor: doc === null || doc === void 0 ? void 0 : (ref6 = doc.data) === null || ref6 === void 0 ? void 0 : ref6.header_text_color,
                background: doc === null || doc === void 0 ? void 0 : (ref7 = doc.data) === null || ref7 === void 0 ? void 0 : ref7.header_background,
                hoverColor: doc === null || doc === void 0 ? void 0 : (ref8 = doc.data) === null || ref8 === void 0 ? void 0 : ref8.header_text_hover_color,
                basket: basket,
                takeback: takeback,
                submenuBackgroundColor: doc === null || doc === void 0 ? void 0 : (ref9 = doc.data) === null || ref9 === void 0 ? void 0 : ref9.header_submenu_background_color,
                submenuTextColor: doc === null || doc === void 0 ? void 0 : (ref10 = doc.data) === null || ref10 === void 0 ? void 0 : ref10.header_submenu_text_color,
                isBanner: isBanner,
                isDisplayedBannerOnAllPages: isDisplayedBannerOnAllPages,
                banner: banner,
                pageName: pageName
            }),
            children,
            !(doc === null || doc === void 0 ? void 0 : (ref11 = doc.data) === null || ref11 === void 0 ? void 0 : ref11.hide_footer) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Footer__WEBPACK_IMPORTED_MODULE_2__["default"], {
                doc: doc,
                t: t,
                hideTop: hideTop
            })
        ]
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (Layout);


/***/ }),

/***/ 79481:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(75154);

var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)({
        form: {
            position: 'relative',
            marginTop: theme.spacing(2)
        },
        input: {
            display: 'block',
            padding: theme.spacing(1, 1.25),
            fontFamily: theme.typography.fontFamily,
            fontSize: 14,
            borderRadius: theme.spacing(0.75),
            border: "1px solid ".concat(theme.extraColors.greyLight),
            color: theme.typography.body1.color,
            backgroundColor: theme.extraColors.greyLight,
            WebkitAppearance: 'none',
            '&::placeholder': {
                opacity: 0.75,
                color: theme.typography.body1.color
            },
            '&:disabled': {
                userSelect: 'none',
                cursor: 'not-allowed'
            }
        },
        label: {
            display: 'block',
            cursor: 'pointer',
            fontSize: 9,
            paddingLeft: theme.spacing(1.25),
            marginBottom: theme.spacing(0.5)
        },
        cgu: {
            lineHeight: 1.4,
            display: 'block'
        },
        customCgl: {
            marginLeft: theme.spacing(4)
        },
        centeredButton: {
            textAlign: 'center'
        },
        submit: {
            marginTop: theme.spacing(1),
            marginBottom: theme.spacing(2)
        },
        overlay: {
            position: 'absolute',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: 'rgba(255,255,255, .8)',
            backdropFilter: 'blur(2px)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
        },
        overlayIcon: {
            width: '2em',
            height: '2em',
            color: theme.palette.success.main
        },
        hide: {
            opacity: 0,
            transition: theme.transitions.create('opacity')
        },
        show: {
            opacity: 1,
            transition: theme.transitions.create('opacity')
        },
        inProgress: {
            overflow: 'hidden',
            '& >span': {
                position: 'relative',
                zIndex: 2
            },
            '&:before': {
                content: '""',
                zIndex: 1,
                position: 'absolute',
                top: 0,
                left: 0,
                bottom: 0,
                right: 0,
                backgroundColor: theme.palette.secondary.main,
                animation: '$progress 15s forwards',
                transformOrigin: 'left',
                willChange: 'transform'
            }
        },
        '@keyframes progress': {
            '0%': {
                transform: 'scale3d(0, 1, 1)'
            },
            '20%': {
                transform: 'scale3d(0.8, 1, 1)'
            },
            '80%': {
                transform: 'scale3d(0.9, 1, 1)'
            },
            '100%': {
                transform: 'scale3d(1.1, 1, 1)'
            }
        }
    });
});
/* harmony default export */ __webpack_exports__["Z"] = (useStyles);


/***/ }),

/***/ 75900:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41120);
/* harmony import */ var _material_ui_core__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(75154);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _Global_CMSText__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(94455);




var useStyles = (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function(theme) {
    return (0,_material_ui_core__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        root: {
            display: 'block',
            height: 200,
            border: "1px solid ".concat(theme.palette.primary.main),
            textAlign: 'justify',
            overflowY: 'scroll',
            margin: theme.spacing(1),
            padding: theme.spacing(1)
        }
    });
});
var TextBox = function(param) {
    var text = param.text;
    var classes = useStyles();
    return(/*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: text && text.length > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
            className: classes.root,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Global_CMSText__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .ZP, {
                data: text
            })
        })
    }));
};
/* harmony default export */ __webpack_exports__["Z"] = (TextBox);


/***/ }),

/***/ 45733:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "V": function() { return /* binding */ useCartHasStockError; }
/* harmony export */ });
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36456);
/* harmony import */ var _utils_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(16502);


function useCartHasStockError() {
    var ref, ref1, ref2;
    var cart = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        return state.cart;
    });
    var stock = (0,react_redux__WEBPACK_IMPORTED_MODULE_0__/* .useSelector */ .v9)(function(state) {
        return state.stock;
    });
    if (!(cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : (ref1 = ref.items) === null || ref1 === void 0 ? void 0 : ref1.length)) return false;
    if (!(stock === null || stock === void 0 ? void 0 : (ref2 = stock.stockBasket) === null || ref2 === void 0 ? void 0 : ref2.length)) return false;
    return cart.item.items.some(function(product) {
        var availability = (0,_utils_utils__WEBPACK_IMPORTED_MODULE_1__/* .checkStockQuantityByItemType */ .qe)(stock, product.product.variants[0], product.type, 'basket');
        return product.quantity > (availability !== null && availability !== void 0 ? availability : 0);
    });
}


/***/ }),

/***/ 25630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "v": function() { return /* binding */ useInformationSkipped; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var react_redux__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(36456);
/* harmony import */ var _redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(14596);
/* harmony import */ var _utils_constants__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(66026);




/**
 * État effectif « étape /information sautée », robuste au rafraîchissement.
 *
 * - Lit le flag persisté (posé par /information lors du skip réel) ;
 * - sinon le redérive depuis l'état utilisateur (connecté + adresse), ce qui
 *   reproduit la condition de redirection automatique de /information ;
 * - resynchronise le flag redux pour les navigations suivantes.
 *
 * À utiliser sur les pages post-information (shipping, order-reference, payment)
 * pour masquer l'onglet « Information » du stepper même après un refresh.
 */ function useInformationSkipped() {
    var dispatch = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useDispatch */ .I0)();
    var stored = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        var ref;
        return (ref = state.cart) === null || ref === void 0 ? void 0 : ref.informationSkipped;
    });
    var isLoggedIn = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        var ref;
        return (ref = state.user) === null || ref === void 0 ? void 0 : ref.isLoggedIn;
    });
    var addressCity = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        var ref, ref1, ref2;
        return (ref = state.user) === null || ref === void 0 ? void 0 : (ref1 = ref.user) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.address) === null || ref2 === void 0 ? void 0 : ref2.city;
    });
    var billingAddress = (0,react_redux__WEBPACK_IMPORTED_MODULE_1__/* .useSelector */ .v9)(function(state) {
        var ref, ref3;
        return (ref = state.cart) === null || ref === void 0 ? void 0 : (ref3 = ref.item) === null || ref3 === void 0 ? void 0 : ref3.billingAddress;
    });
    var derived = !!isLoggedIn && !!addressCity && (!_utils_constants__WEBPACK_IMPORTED_MODULE_3__/* .isB2B */ .tP || !!billingAddress);
    var effective = Boolean(stored) || derived;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        if (effective && !stored) {
            dispatch((0,_redux_actions_cart__WEBPACK_IMPORTED_MODULE_2__/* .setInformationSkipped */ .JM)(true));
        }
    }, [
        effective,
        stored,
        dispatch
    ]);
    return effective;
}


/***/ }),

/***/ 61529:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ payment; }
});

// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.m.js
var clsx_m = __webpack_require__(86010);
// EXTERNAL MODULE: ./node_modules/react-redux/es/index.js + 18 modules
var es = __webpack_require__(36456);
// EXTERNAL MODULE: ./redux/actions/prismic.ts
var prismic = __webpack_require__(64063);
// EXTERNAL MODULE: ./node_modules/@stripe/react-stripe-js/dist/react-stripe.umd.js
var react_stripe_umd = __webpack_require__(86664);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Container/Container.js
var Container = __webpack_require__(43832);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/FormControlLabel/FormControlLabel.js
var FormControlLabel = __webpack_require__(30553);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Checkbox/Checkbox.js + 3 modules
var Checkbox = __webpack_require__(80797);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/makeStyles.js
var makeStyles = __webpack_require__(41120);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/createStyles.js + 1 modules
var createStyles = __webpack_require__(75154);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Fade/Fade.js
var Fade = __webpack_require__(73637);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/CheckCircle.js
var CheckCircle = __webpack_require__(81395);
// EXTERNAL MODULE: ./components/Loader/Loader.tsx
var Loader = __webpack_require__(96149);
// EXTERNAL MODULE: ./components/Button/Button.tsx
var Button = __webpack_require__(41107);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./typings/base.ts
var base = __webpack_require__(88039);
// EXTERNAL MODULE: ./redux/actions/checkout.ts
var checkout = __webpack_require__(66397);
// EXTERNAL MODULE: ./node_modules/@datapunt/matomo-tracker-react/es/useMatomo.js + 1 modules
var useMatomo = __webpack_require__(86700);
// EXTERNAL MODULE: ./utils/utils.tsx
var utils = __webpack_require__(16502);
// EXTERNAL MODULE: ./components/Link/Link.tsx
var Link = __webpack_require__(31520);
// EXTERNAL MODULE: ./components/Global/CMSText.tsx
var CMSText = __webpack_require__(94455);
// EXTERNAL MODULE: ./components/PaymentForm/CardForm.style.tsx
var CardForm_style = __webpack_require__(79481);
// EXTERNAL MODULE: ./utils/constants.tsx
var constants = __webpack_require__(66026);
// EXTERNAL MODULE: ./redux/helpers/api.ts + 1 modules
var api = __webpack_require__(12664);
// EXTERNAL MODULE: ./redux/helpers/requests.ts
var requests = __webpack_require__(20031);
;// CONCATENATED MODULE: ./redux/services/payment.tsx




var postDadPayment = function(data, token) {
    var storesWithBearerToken = [
        'thermor-2ndhand',
        'atlantic-2ndhand'
    ];
    var shouldSendBearerToken = storesWithBearerToken.includes("millet");
    var authToken =  true && shouldSendBearerToken ? localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN) : null;
    var headers = authToken ? {
        Authorization: "Bearer ".concat(authToken)
    } : {};
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.post */.YZ.post,
        url: requests/* ERequestUrl.payment */.KU.payment,
        data: data,
        uid: "".concat(token, "/complete-dad-order")
    });
};
var postBypassDadPayment = function(data, token) {
    var authToken = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN);
    var headers = authToken ? (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE)) : {};
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.post */.YZ.post,
        url: requests/* ERequestUrl.payment */.KU.payment,
        data: data,
        uid: "bypass/".concat(token, "/complete-dad-order"),
        headers: headers
    });
};
var postSubPayment = function(data, token) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.post */.YZ.post,
        url: requests/* ERequestUrl.payment */.KU.payment,
        data: data,
        headers: (0,utils/* apiHeaders */.pW)(localStorage.getItem('connexion-type')),
        uid: "".concat(token, "/complete-sub-order")
    });
};
var postWireTransferDadPayment = function(data, token) {
    var authToken = localStorage === null || localStorage === void 0 ? void 0 : localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.TOKEN */.dA.TOKEN);
    var headers = authToken ? (0,utils/* apiHeaders */.pW)(localStorage.getItem(constants/* LOCAL_STORAGE_KEYS.CONNEXION_TYPE */.dA.CONNEXION_TYPE)) : {};
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.post */.YZ.post,
        url: requests/* ERequestUrl.payment */.KU.payment,
        data: data,
        uid: "wire-transfer/".concat(token, "/complete-dad-order"),
        headers: headers
    });
};
var postFinalizeDadPayment = function(data, token) {
    return (0,api/* default */.ZP)({
        method: requests/* EMethods.post */.YZ.post,
        url: requests/* ERequestUrl.payment */.KU.payment,
        data: data,
        uid: "".concat(token, "/finalize-post-payment")
    });
};

;// CONCATENATED MODULE: ./redux/actions/payment.tsx

var ACTIONS = {
    POST_DAD_PAYMENT_REQUEST: 'POST_DAD_PAYMENT_REQUEST',
    POST_DAD_PAYMENT_SUCCESS: 'POST_DAD_PAYMENT_SUCCESS',
    POST_DAD_PAYMENT_FAILURE: 'POST_DAD_PAYMENT_FAILURE ',
    POST_SUB_PAYMENT_REQUEST: 'POST_SUB_PAYMENT_REQUEST',
    POST_SUB_PAYMENT_SUCCESS: 'POST_SUB_PAYMENT_SUCCESS',
    POST_SUB_PAYMENT_FAILURE: 'POST_SUB_PAYMENT_FAILURE ',
    POST_FINALIZE_DAD_PAYMENT_REQUEST: 'POST_FINALIZE_DAD_PAYMENT_REQUEST',
    POST_FINALIZE_DAD_PAYMENT_SUCCESS: 'POST_FINALIZE_DAD_PAYMENT_SUCCESS',
    POST_FINALIZE_DAD_PAYMENT_FAILURE: 'POST_FINALIZE_DAD_PAYMENT_FAILURE '
};
var POST_DAD_PAYMENT_REQUEST = function() {
    return {
        type: ACTIONS.POST_DAD_PAYMENT_REQUEST
    };
};
var POST_DAD_PAYMENT_SUCCESS = function(paymentResult) {
    return {
        type: ACTIONS.POST_DAD_PAYMENT_SUCCESS,
        paymentResult: paymentResult
    };
};
var POST_DAD_PAYMENT_FAILURE = function(err) {
    return {
        type: ACTIONS.POST_DAD_PAYMENT_FAILURE,
        err: err
    };
};
function payment_postDadPayment(data, token) {
    return function(dispatch) {
        dispatch(POST_DAD_PAYMENT_REQUEST());
        return postDadPayment(data, token).then(function(response) {
            return dispatch(POST_DAD_PAYMENT_SUCCESS(response));
        }, function(err) {
            return dispatch(POST_DAD_PAYMENT_FAILURE(err));
        });
    };
}
function payment_postBypassDadPayment(data, token) {
    return function(dispatch) {
        dispatch(POST_DAD_PAYMENT_REQUEST());
        return postBypassDadPayment(data, token).then(function(response) {
            return dispatch(POST_DAD_PAYMENT_SUCCESS(response));
        }, function(err) {
            return dispatch(POST_DAD_PAYMENT_FAILURE(err));
        });
    };
}
function payment_postWireTransferDadPayment(data, token) {
    return function(dispatch) {
        dispatch(POST_DAD_PAYMENT_REQUEST());
        return postWireTransferDadPayment(data, token).then(function(response) {
            return dispatch(POST_DAD_PAYMENT_SUCCESS(response));
        }, function(err) {
            return dispatch(POST_DAD_PAYMENT_FAILURE(err));
        });
    };
}
var POST_SUB_PAYMENT_REQUEST = function() {
    return {
        type: ACTIONS.POST_SUB_PAYMENT_REQUEST
    };
};
var POST_SUB_PAYMENT_SUCCESS = function(paymentResult) {
    return {
        type: ACTIONS.POST_SUB_PAYMENT_SUCCESS,
        paymentResult: paymentResult
    };
};
var POST_SUB_PAYMENT_FAILURE = function(err) {
    return {
        type: ACTIONS.POST_SUB_PAYMENT_FAILURE,
        err: err
    };
};
function payment_postSubPayment(data, token) {
    return function(dispatch) {
        dispatch(POST_SUB_PAYMENT_REQUEST());
        return postSubPayment(data, token).then(function(response) {
            return dispatch(POST_SUB_PAYMENT_SUCCESS(response));
        }, function(err) {
            return dispatch(POST_SUB_PAYMENT_FAILURE(err));
        });
    };
}
var POST_FINALIZE_DAD_PAYMENT_REQUEST = function() {
    return {
        type: ACTIONS.POST_FINALIZE_DAD_PAYMENT_REQUEST
    };
};
var POST_FINALIZE_DAD_PAYMENT_SUCCESS = function(result) {
    return {
        type: ACTIONS.POST_FINALIZE_DAD_PAYMENT_SUCCESS,
        result: result
    };
};
var POST_FINALIZE_DAD_PAYMENT_FAILURE = function(err) {
    return {
        type: ACTIONS.POST_FINALIZE_DAD_PAYMENT_FAILURE,
        err: err
    };
};
function payment_postFinalizeDadPayment(data, token) {
    return function(dispatch) {
        dispatch(POST_FINALIZE_DAD_PAYMENT_REQUEST());
        return postFinalizeDadPayment(data, token).then(function(response) {
            return dispatch(POST_FINALIZE_DAD_PAYMENT_SUCCESS(response));
        }, function(err) {
            return dispatch(POST_FINALIZE_DAD_PAYMENT_FAILURE(err));
        });
    };
}

// EXTERNAL MODULE: ./utils/gtag.ts
var gtag = __webpack_require__(65809);
// EXTERNAL MODULE: ./node_modules/dayjs/dayjs.min.js
var dayjs_min = __webpack_require__(27484);
var dayjs_min_default = /*#__PURE__*/__webpack_require__.n(dayjs_min);
;// CONCATENATED MODULE: ./components/PaymentForm/hook/useRetractationEffect.tsx


var useRetractationEffect = function(param) {
    var startLeasingDate = param.startLeasingDate, isRetractation = param.isRetractation, retractingDays = param.retractingDays, setRetractReady = param.setRetractReady, setRetractAgree = param.setRetractAgree;
    (0,react.useEffect)(function() {
        if (startLeasingDate && isRetractation && retractingDays) {
            // we enable another agreement if start leasing date is in 14 days.
            if (dayjs_min_default()(dayjs_min_default()(startLeasingDate, 'DD/MM/YYYY'), 'd').diff(dayjs_min_default()(), 'd') < retractingDays) {
                setRetractReady(true);
                setRetractAgree(false);
            } else {
                setRetractReady(false);
                setRetractAgree(true);
            }
        } else {
            setRetractAgree(true);
        }
    }, [
        startLeasingDate,
        isRetractation,
        retractingDays,
        setRetractReady,
        setRetractAgree, 
    ]);
};
/* harmony default export */ var hook_useRetractationEffect = (useRetractationEffect);

;// CONCATENATED MODULE: ./components/PaymentForm/PaymentFormStripe.tsx























function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: {},
        payStatus: {
            minHeight: '2em',
            margin: theme.spacing(0, 0, 2)
        }
    });
});
var PaymentFormStripe = function(param1) {
    var cart = param1.cart, postDadPayment1 = param1.postDadPayment, postSubPayment1 = param1.postSubPayment, t = param1.t, text = param1.text, settings = param1.settings, createCheckoutPayment1 = param1.createCheckoutPayment, startLeasingDate = param1.startLeasingDate, coupon = param1.coupon, swikId = param1.swikId, disabled = param1.disabled;
    var commonClasses = (0,CardForm_style/* default */.Z)();
    var classes = useStyles();
    var router = (0,next_router.useRouter)();
    var ref12 = (0,react.useState)(false), cardNumberComplete = ref12[0], setCardNumberComplete = ref12[1];
    var ref1 = (0,react.useState)(false), expiryDateComplete = ref1[0], setExpiryDateComplete = ref1[1];
    var ref2 = (0,react.useState)(false), cvcComplete = ref2[0], setCvcComplete = ref2[1];
    var ref3 = (0,react.useState)(false), paymentProcessing = ref3[0], setPaymentProcessing = ref3[1];
    var ref4 = (0,react.useState)(true), paymentFailed = ref4[0], setPaymentFailed = ref4[1];
    var ref5 = (0,react.useState)(false), cgu = ref5[0], setCgu = ref5[1];
    var ref6 = (0,react.useState)(false), cguError = ref6[0], setCguError = ref6[1];
    var ref7 = (0,useMatomo/* default */.Z)(), trackEvent = ref7.trackEvent, pushInstruction = ref7.pushInstruction;
    var ref8 = (0,react.useState)(false), retractReady = ref8[0], setRetractReady = ref8[1];
    var ref9 = (0,react.useState)(false), retractAgree = ref9[0], setRetractAgree = ref9[1];
    var isRetractation = text === null || text === void 0 ? void 0 : text.enable_retractation_agreement;
    var retractingDays = text === null || text === void 0 ? void 0 : text.retractation_duration;
    var ref10 = (0,react.useState)(''), registeredStoreSlug = ref10[0], setRegisteredStoreSlug = ref10[1];
    (0,react.useEffect)(function() {
        var ref;
        typeof localStorage !== 'undefined' && setRegisteredStoreSlug((ref = JSON.parse(localStorage.getItem('selectedStore'))) === null || ref === void 0 ? void 0 : ref.slug);
    }, []);
    var changeCgu = function() {
        setCgu(!cgu);
    };
    var changeRetract = function() {
        setRetractAgree(!retractAgree);
    };
    var ref11 = (0,react.useState)(null), error1 = ref11[0], setError = ref11[1];
    var stripe = (0,react_stripe_umd.useStripe)();
    var elements = (0,react_stripe_umd.useElements)();
    (0,react.useEffect)(function() {
        var ref, ref13;
        if (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.insufficient_funds) {
            setError(t('texts:funnel:payment:errors:insufficient_funds'));
        } else if (router === null || router === void 0 ? void 0 : (ref13 = router.query) === null || ref13 === void 0 ? void 0 : ref13.error_3D) {
            setError(t('texts:funnel:payment:error'));
        }
    }, [
        router === null || router === void 0 ? void 0 : router.query
    ]);
    hook_useRetractationEffect({
        startLeasingDate: startLeasingDate,
        isRetractation: isRetractation,
        retractingDays: retractingDays,
        setRetractReady: setRetractReady,
        setRetractAgree: setRetractAgree
    });
    // Handle form submission.
    var handleSubmit = function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(event) {
            var card, result, linkLocal, ref47, ref14, ref15, data, payment, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, gaParams, cleanGAParams, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, error, ref44, productName;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(cgu && retractAgree)) {
                            _ctx.next = 95;
                            break;
                        }
                        setCguError(false);
                        setPaymentProcessing(true);
                        trackEvent({
                            category: 'Payment',
                            action: "User click on pay button"
                        });
                        if (!(cardNumberComplete && expiryDateComplete && cvcComplete)) {
                            _ctx.next = 92;
                            break;
                        }
                        event.preventDefault();
                        card = elements.getElement(react_stripe_umd.CardNumberElement);
                        _ctx.next = 9;
                        return stripe.createToken(card);
                    case 9:
                        result = _ctx.sent;
                        linkLocal = router.locale ? "/".concat(router.locale) : '';
                        if (!result.error) {
                            _ctx.next = 15;
                            break;
                        }
                        {
                            // Inform the user if there was an error.
                            setError(result.error.message);
                            setPaymentProcessing(false);
                            setPaymentFailed(true);
                        }
                        _ctx.next = 90;
                        break;
                    case 15:
                        ;
                        _ctx.next = 18;
                        return createCheckoutPayment1(cart.item.tokenValue);
                    case 18:
                        setError(null);
                        data = {
                            email: localStorage.getItem('email'),
                            last4: result.token.card.last4,
                            token: result.token.id,
                            frontSuccessPaymentUrl: "".concat(window.location.origin).concat(linkLocal, "/confirmation"),
                            frontFailPaymentUrl: "".concat(window.location.origin).concat(linkLocal, "/payment?error_3D=true"),
                            swik_id: swikId
                        };
                        // add parcelShop id if exist
                        if (((ref14 = cart === null || cart === void 0 ? void 0 : (ref47 = cart.item) === null || ref47 === void 0 ? void 0 : ref47.shipments[0].method) === null || ref14 === void 0 ? void 0 : ref14.type) !== 'HOME_DELIVERY' && typeof localStorage.getItem('rmsParcelShopId') !== 'undefined' && localStorage.getItem('rmsParcelShopId') !== null) {
                            data['parcelShopId'] = localStorage.getItem('rmsParcelShopId');
                        }
                        payment = null;
                        if (constants/* isSubscription */.Nn) {
                            _ctx.next = 28;
                            break;
                        }
                        _ctx.next = 25;
                        return postDadPayment1(data, cart.item.tokenValue);
                    case 25:
                        payment = _ctx.sent;
                        _ctx.next = 31;
                        break;
                    case 28:
                        _ctx.next = 30;
                        return postSubPayment1(data, cart.item.tokenValue);
                    case 30:
                        payment = _ctx.sent;
                    case 31:
                        if (!((payment === null || payment === void 0 ? void 0 : (ref15 = payment.paymentResult) === null || ref15 === void 0 ? void 0 : ref15.stripe_payment_status) === 'requires_action')) {
                            _ctx.next = 35;
                            break;
                        }
                        {
                            // Because of 3d secure we open a new window, causing an unstable redux state.
                            // We set a local storage item in order to keep track of payment in confirmation page
                            localStorage.setItem('Payment type', '3dSecure');
                            window.open(payment.paymentResult.next_action.redirect_to_url.url, '_self').focus();
                        }
                        _ctx.next = 90;
                        break;
                    case 35:
                        if (!(payment.paymentResult === 'Order completed')) {
                            _ctx.next = 50;
                            break;
                        }
                        ;
                        setPaymentProcessing(false);
                        setPaymentFailed(false);
                        _ctx.next = 41;
                        return pushInstruction('trackEcommerceOrder', cart === null || cart === void 0 ? void 0 : (ref16 = cart.item) === null || ref16 === void 0 ? void 0 : ref16.tokenValue, (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref17 = cart.item) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.totals) === null || ref18 === void 0 ? void 0 : ref18.total), (0,utils/* numberToPrice */.e8)((cart === null || cart === void 0 ? void 0 : (ref19 = cart.item) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.totals) === null || ref20 === void 0 ? void 0 : ref20.total) - (cart === null || cart === void 0 ? void 0 : (ref21 = cart.item) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.totals) === null || ref22 === void 0 ? void 0 : ref22.shipping)), (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref23 = cart.item) === null || ref23 === void 0 ? void 0 : (ref24 = ref23.totals) === null || ref24 === void 0 ? void 0 : ref24.taxes), (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref25 = cart.item) === null || ref25 === void 0 ? void 0 : (ref26 = ref25.totals) === null || ref26 === void 0 ? void 0 : ref26.shipping), (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref27 = cart.item) === null || ref27 === void 0 ? void 0 : (ref28 = ref27.totals) === null || ref28 === void 0 ? void 0 : ref28.promotion) // discount (Optional) – Integer/Float/Boolean – Discount offered? Default to false. Otherwise, you should include a numeric value.
                        );
                    case 41:
                        gaParams = {
                            transaction_id: cart === null || cart === void 0 ? void 0 : (ref29 = cart.item) === null || ref29 === void 0 ? void 0 : ref29.tokenValue,
                            currency: cart.item.currency,
                            value: (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref30 = cart.item) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.totals) === null || ref31 === void 0 ? void 0 : ref31.total),
                            tax: (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref32 = cart.item) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.totals) === null || ref33 === void 0 ? void 0 : ref33.taxes),
                            shipping: (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref34 = cart.item) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.totals) === null || ref35 === void 0 ? void 0 : ref35.shipping),
                            items: cart.item.items.map(function(param) {
                                var product = param.product, quantity = param.quantity, total = param.total;
                                var firstVariant = Object.values(product === null || product === void 0 ? void 0 : product.variants)[0];
                                var _obj;
                                return _obj = {}, _defineProperty(_obj, 'item_name', product.name), _defineProperty(_obj, 'item_id', gtag/* isChalhoub */.LP ? firstVariant.sku : product.code), _defineProperty(_obj, 'item_variant', gtag/* isChalhoub */.LP && firstVariant.code), _defineProperty(_obj, "price", (0,utils/* numberToPrice */.e8)(total)), _defineProperty(_obj, "quantity", quantity), _obj;
                            })
                        };
                        cleanGAParams = (0,gtag/* clearItemVariantFromGAParamsIfNotChalhoub */.o9)(gaParams);
                        gtag/* tracker */.ap(base/* GAEvent.PURCHASE */.gB.PURCHASE, cleanGAParams);
                        (0,gtag/* safeDataLayerPush */.Kx)((0,gtag/* getPaymentInfoGtmData */.yo)(cart, coupon, 'stripe'));
                        // Meta Pixel: Purchase event with amount and currency
                        if ( true && typeof window.fbq === 'function') {
                            ;
                            window.fbq('track', 'Purchase', {
                                value: (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref36 = cart.item) === null || ref36 === void 0 ? void 0 : (ref37 = ref36.totals) === null || ref37 === void 0 ? void 0 : ref37.total),
                                currency: cart === null || cart === void 0 ? void 0 : (ref38 = cart.item) === null || ref38 === void 0 ? void 0 : ref38.currency
                            });
                        }
                        _ctx.next = 48;
                        return router.push('/confirmation');
                    case 48:
                        _ctx.next = 90;
                        break;
                    case 50:
                        ;
                        if (!((payment === null || payment === void 0 ? void 0 : (ref39 = payment.err) === null || ref39 === void 0 ? void 0 : (ref40 = ref39.response) === null || ref40 === void 0 ? void 0 : ref40.data) === constants/* minimumCartItemsNotReached */.Wf)) {
                            _ctx.next = 55;
                            break;
                        }
                        {
                            setError(t('texts:funnel:payment:errors:minimum_cart_items'));
                        }
                        _ctx.next = 88;
                        break;
                    case 55:
                        ;
                        error = payment === null || payment === void 0 ? void 0 : (ref41 = payment.err) === null || ref41 === void 0 ? void 0 : (ref42 = ref41.response) === null || ref42 === void 0 ? void 0 : (ref43 = ref42.data) === null || ref43 === void 0 ? void 0 : ref43.error;
                        if (!(error === 'some products are not available in stocks')) {
                            _ctx.next = 61;
                            break;
                        }
                        {
                            ;
                            productName = '';
                            cart === null || cart === void 0 ? void 0 : (ref44 = cart.item) === null || ref44 === void 0 ? void 0 : ref44.items.map(function(products) {
                                productName = products.product.variants.find(function(variants) {
                                    var ref, ref45, ref46;
                                    return variants.code === (payment === null || payment === void 0 ? void 0 : (ref = payment.err) === null || ref === void 0 ? void 0 : (ref45 = ref.response) === null || ref45 === void 0 ? void 0 : (ref46 = ref45.data) === null || ref46 === void 0 ? void 0 : ref46.unavailableProductVariants[0]);
                                }).name;
                            });
                            setError("".concat(t('texts:funnel:payment:errors:stock'), " : ").concat(productName));
                        }
                        _ctx.next = 88;
                        break;
                    case 61:
                        if (!((error === null || error === void 0 ? void 0 : error.code) === 'card_declined')) {
                            _ctx.next = 77;
                            break;
                        }
                        _ctx.t0 = error === null || error === void 0 ? void 0 : error.decline_code;
                        _ctx.next = _ctx.t0 === 'insufficient_funds' ? 65 : _ctx.t0 === 'lost_card' ? 67 : _ctx.t0 === 'stolen_card' ? 69 : _ctx.t0 === 'Invalid email address' ? 71 : 73;
                        break;
                    case 65:
                        setError(t('texts:funnel:payment:errors:insufficient_funds'));
                        return _ctx.abrupt("break", 75);
                    case 67:
                        setError(t('texts:funnel:payment:errors:lost_card'));
                        return _ctx.abrupt("break", 75);
                    case 69:
                        setError(t('texts:funnel:payment:errors:stolen_card'));
                        return _ctx.abrupt("break", 75);
                    case 71:
                        setError(t('texts:funnel:payment:errors:email'));
                        return _ctx.abrupt("break", 75);
                    case 73:
                        setError(t('texts:funnel:payment:errors:default'));
                        return _ctx.abrupt("break", 75);
                    case 75:
                        _ctx.next = 88;
                        break;
                    case 77:
                        _ctx.t1 = error === null || error === void 0 ? void 0 : error.code;
                        _ctx.next = _ctx.t1 === 'expired_card' ? 80 : _ctx.t1 === 'incorrect_cvc' ? 82 : _ctx.t1 === 'processing_error' ? 84 : 86;
                        break;
                    case 80:
                        setError(t('texts:funnel:payment:errors:expired_card'));
                        return _ctx.abrupt("break", 88);
                    case 82:
                        setError(t('texts:funnel:payment:errors:incorrect_cvc'));
                        return _ctx.abrupt("break", 88);
                    case 84:
                        setError(t('texts:funnel:payment:errors:processing_error'));
                        return _ctx.abrupt("break", 88);
                    case 86:
                        setError(t('texts:funnel:payment:errors:default'));
                        return _ctx.abrupt("break", 88);
                    case 88:
                        setPaymentProcessing(false);
                        setPaymentFailed(true);
                    case 90:
                        _ctx.next = 93;
                        break;
                    case 92:
                        {
                            setPaymentFailed(true);
                        }
                    case 93:
                        _ctx.next = 96;
                        break;
                    case 95:
                        {
                            setCguError(true);
                        }
                    case 96:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleSubmit(event) {
            return _ref.apply(this, arguments);
        };
    }();
    var _obj1;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.root,
        id: 'root',
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("form", {
            name: "payment-form",
            className: commonClasses.form,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                    className: (0,clsx_m/* default */.Z)('label', commonClasses.label),
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: settings === null || settings === void 0 ? void 0 : settings.card_number,
                                        defaultText: t('texts:general:card_number')
                                    })
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.CardNumberElement, {
                                    className: (0,clsx_m/* default */.Z)('input', commonClasses.input),
                                    onChange: function(e) {
                                        return setCardNumberComplete(e.complete);
                                    }
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                            container: true,
                            justify: 'space-between',
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                    xs: 5,
                                    item: true,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,clsx_m/* default */.Z)('label', commonClasses.label),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: settings === null || settings === void 0 ? void 0 : settings.expiry_date,
                                                defaultText: t('texts:general:expiry_date')
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.CardExpiryElement, {
                                            className: (0,clsx_m/* default */.Z)('input', commonClasses.input),
                                            onChange: function(e) {
                                                return setExpiryDateComplete(e.complete);
                                            }
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                    xs: 5,
                                    item: true,
                                    className: "cb-infos",
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                            className: (0,clsx_m/* default */.Z)('label', commonClasses.label),
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                asText: true,
                                                data: settings === null || settings === void 0 ? void 0 : settings.cvc_code,
                                                defaultText: t('texts:general:cvc_code')
                                            })
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.CardCvcElement, {
                                            className: (0,clsx_m/* default */.Z)('input', commonClasses.input),
                                            onChange: function(e) {
                                                return setCvcComplete(e.complete);
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                checked: cgu,
                                onChange: changeCgu,
                                name: "checkedA",
                                "data-testid": 'cgu_check'
                            }),
                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                variant: 'body2',
                                component: 'span',
                                className: commonClasses.cgu,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    data: text === null || text === void 0 ? void 0 : text.cgu,
                                    defaultText: t('texts:funnel:payment:cgu')
                                })
                            })
                        }),
                        registeredStoreSlug && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: 'body2',
                            component: 'span',
                            className: commonClasses.customCgl,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                href: "/pages/cgl-".concat(registeredStoreSlug),
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        data: text === null || text === void 0 ? void 0 : text.custom_cgu_link,
                                        asText: true,
                                        defaultText: t('texts:funnel:payment:custom_cgu_link')
                                    })
                                })
                            })
                        })
                    ]
                }),
                isRetractation && retractReady && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                    control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                        checked: retractAgree,
                        onChange: changeRetract,
                        name: "retractation",
                        "data-testid": 'retract_check'
                    }),
                    label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: 'body2',
                        component: 'span',
                        className: commonClasses.cgu,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            data: text === null || text === void 0 ? void 0 : text.retractation_agreement,
                            defaultText: t('texts:funnel:payment:retractation_agreement')
                        })
                    })
                }),
                paymentFailed && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    color: 'error',
                    variant: 'caption',
                    align: 'center',
                    component: "div",
                    children: error1
                }),
                cguError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    color: 'secondary',
                    variant: 'caption',
                    align: 'center',
                    component: "div",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        asText: true,
                        data: text === null || text === void 0 ? void 0 : text.cgu_error,
                        defaultText: t('texts:funnel:payment:cgu_error')
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                    className: commonClasses.centeredButton,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                            disabled: paymentProcessing || !cardNumberComplete || !expiryDateComplete || !cvcComplete || !cgu || !retractAgree || disabled,
                            className: (0,clsx_m/* default */.Z)(commonClasses.submit, 'payment-form__submit', (_obj1 = {}, _defineProperty(_obj1, commonClasses.inProgress, paymentProcessing), _defineProperty(_obj1, 'payment-form__submit-progress', paymentProcessing), _obj1)),
                            variant: "contained",
                            "data-testid": "paymentSubmit",
                            color: "primary",
                            onClick: handleSubmit,
                            type: "submit",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                    className: paymentProcessing ? commonClasses.hide : commonClasses.show,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                        asText: true,
                                        data: text === null || text === void 0 ? void 0 : text.pay,
                                        defaultText: t('texts:funnel:pay')
                                    })
                                }),
                                paymentProcessing && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                            className: classes.payStatus,
                            children: [
                                paymentProcessing && /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                                    in: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        component: "span",
                                        variant: "body2",
                                        children: t('texts:funnel:payment:progress')
                                    })
                                }),
                                !paymentFailed && /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                                    in: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        color: 'secondary',
                                        variant: 'body1',
                                        align: 'center',
                                        children: error1
                                    })
                                }),
                                cguError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                                    in: true,
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        color: 'secondary',
                                        variant: 'body1',
                                        align: 'center',
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: text === null || text === void 0 ? void 0 : text.cgu_error,
                                            defaultText: t('funnel:cgu_error')
                                        })
                                    })
                                })
                            ]
                        })
                    ]
                }),
                !paymentFailed && /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                    in: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: commonClasses.overlay,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckCircle/* default */.Z, {
                                className: commonClasses.overlayIcon
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: "h2",
                                variant: "h3",
                                children: t('texts:funnel:payment:success')
                            })
                        ]
                    })
                })
            ]
        })
    }));
};
var mapStateToProps = function(state) {
    return {
        cart: state.cart
    };
};
var mapDispatchToProps = {
    postDadPayment: payment_postDadPayment,
    postSubPayment: payment_postSubPayment,
    createCheckoutPayment: checkout/* createCheckoutPayment */.dG
};
/* harmony default export */ var PaymentForm_PaymentFormStripe = ((0,es/* connect */.$j)(mapStateToProps, mapDispatchToProps)(PaymentFormStripe));

// EXTERNAL MODULE: ./components/Layout/Layout.tsx
var Layout = __webpack_require__(8122);
// EXTERNAL MODULE: ./components/Funnel/FunnelHeader.tsx
var FunnelHeader = __webpack_require__(15802);
// EXTERNAL MODULE: ./components/Funnel/FunnelBox.tsx
var FunnelBox = __webpack_require__(97991);
// EXTERNAL MODULE: ./components/Funnel/Funnel.style.tsx
var Funnel_style = __webpack_require__(35042);
// EXTERNAL MODULE: ./components/Commitment/Commitment.tsx
var Commitment = __webpack_require__(88737);
// EXTERNAL MODULE: ./node_modules/@material-ui/icons/KeyboardBackspace.js
var KeyboardBackspace = __webpack_require__(64379);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/useTranslation.js + 1 modules
var useTranslation = __webpack_require__(31567);
// EXTERNAL MODULE: ./hooks/useCartHasStockError.ts
var useCartHasStockError = __webpack_require__(45733);
// EXTERNAL MODULE: ./components/TextField/TextField.tsx + 1 modules
var TextField = __webpack_require__(59000);
// EXTERNAL MODULE: ./components/TextField/TextBox.tsx
var TextBox = __webpack_require__(75900);
// EXTERNAL MODULE: ./utils/useStripePromise.tsx
var useStripePromise = __webpack_require__(38962);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/useTheme.js
var useTheme = __webpack_require__(8920);
// EXTERNAL MODULE: ./node_modules/@adyen/adyen-web/dist/es/index.js
var dist_es = __webpack_require__(17985);
;// CONCATENATED MODULE: ./components/PaymentForm/PaymentFormAdyen.tsx
/* provided dependency */ var process = __webpack_require__(34155);






















function PaymentFormAdyen_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function PaymentFormAdyen_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                PaymentFormAdyen_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                PaymentFormAdyen_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function PaymentFormAdyen_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var PaymentFormAdyen_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: {},
        label: {
            marginTop: theme.spacing(2),
            fontSize: 10,
            display: 'block',
            paddingLeft: theme.spacing(1)
        },
        input: {
            display: 'block',
            width: '100%',
            height: "".concat(theme.spacing(2) + 16, "px"),
            padding: theme.spacing(1, 1.25),
            background: theme.extraColors.greyLight,
            border: "1px solid ".concat(theme.extraColors.greyLight),
            borderRadius: theme.spacing(1),
            fontFamily: theme.typography.fontFamily,
            '&::placeholder': {
                opacity: 0.75,
                color: theme.typography.body1.color
            }
        },
        marginBottom: {
            marginBottom: theme.spacing(1)
        },
        mainContainer: {
            alignItems: 'center'
        },
        row: {
            display: 'flex',
            justifyContent: 'space-between',
            width: '100%',
            gap: theme.spacing(2)
        }
    });
});
var PaymentFormAdyen = function(param1) {
    var cart = param1.cart, postDadPayment1 = param1.postDadPayment, postSubPayment1 = param1.postSubPayment, t = param1.t, settings = param1.settings, text = param1.text, createCheckoutPayment1 = param1.createCheckoutPayment, startLeasingDate = param1.startLeasingDate, coupon = param1.coupon, swikId = param1.swikId, disabled = param1.disabled;
    var handleOnChange = function handleOnChange(state) {
        if (!state.isValid) return;
        if (state.isValid) {
            setIsCardValidAdyen(state.isValid);
            setAdyenCardData(state.data.paymentMethod);
            setUserAgent(state.data.browserInfo.userAgent);
        }
    };
    var ref16, ref1, ref2;
    var classes = PaymentFormAdyen_useStyles();
    var commonClasses = (0,CardForm_style/* default */.Z)();
    var theme = (0,useTheme/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react.useState)(false), isCardValidAdyen = ref3[0], setIsCardValidAdyen = ref3[1];
    var ref4 = (0,react.useState)(null), adyenCardData = ref4[0], setAdyenCardData = ref4[1];
    var ref5 = (0,react.useState)(''), userAgent = ref5[0], setUserAgent = ref5[1];
    var ref6 = (0,react.useState)(false), paymentProcessing = ref6[0], setPaymentProcessing = ref6[1];
    var ref7 = (0,react.useState)(true), paymentFailed = ref7[0], setPaymentFailed = ref7[1];
    var ref8 = (0,react.useState)(''), holderName = ref8[0], setHolderName = ref8[1];
    var ref9 = (0,react.useState)(false), cgu = ref9[0], setCgu = ref9[1];
    var ref10 = (0,react.useState)(false), retractReady = ref10[0], setRetractReady = ref10[1];
    var ref11 = (0,react.useState)(false), retractAgree = ref11[0], setRetractAgree = ref11[1];
    var ref12 = (0,react.useState)(false), cguError = ref12[0], setCguError = ref12[1];
    var ref13 = (0,react.useState)(null), error = ref13[0], setError = ref13[1];
    var ref14 = (0,react.useState)(''), registeredStoreSlug = ref14[0], setRegisteredStoreSlug = ref14[1];
    var isRetractation = text === null || text === void 0 ? void 0 : text.enable_retractation_agreement;
    var retractingDays = text === null || text === void 0 ? void 0 : text.retractation_duration;
    var ref15 = (0,useMatomo/* default */.Z)(), trackEvent = ref15.trackEvent, pushInstruction = ref15.pushInstruction;
    (0,react.useEffect)(function() {
        var ref;
        typeof localStorage !== 'undefined' && setRegisteredStoreSlug((ref = JSON.parse(localStorage.getItem('selectedStore'))) === null || ref === void 0 ? void 0 : ref.slug);
    }, []);
    var changeCgu = function() {
        setCgu(!cgu);
    };
    var changeRetract = function() {
        setRetractAgree(!retractAgree);
    };
    var handleHolderName = function(event) {
        var ref;
        setHolderName(event === null || event === void 0 ? void 0 : (ref = event.target) === null || ref === void 0 ? void 0 : ref.value);
    };
    hook_useRetractationEffect({
        startLeasingDate: startLeasingDate,
        isRetractation: isRetractation,
        retractingDays: retractingDays,
        setRetractReady: setRetractReady,
        setRetractAgree: setRetractAgree
    });
    var configuration = {
        locale: cart === null || cart === void 0 ? void 0 : (ref16 = cart.item) === null || ref16 === void 0 ? void 0 : ref16.locale,
        environment: process.env.ADYEN_ENVIRONNEMENT,
        clientKey: process.env.IS_SEPARATE_ADYEN === 'true' && ((ref2 = cart === null || cart === void 0 ? void 0 : (ref1 = cart.item) === null || ref1 === void 0 ? void 0 : ref1.items[0]) === null || ref2 === void 0 ? void 0 : ref2.type) === 'RENTAL' ? process.env.ADYEN_RENTAL_CLIENT_KEY : process.env.ADYEN_CLIENT_KEY,
        onChange: handleOnChange
    };
    var handleAdyenOrder = function() {
        var asyncFunc = function() {
            var _ref = PaymentFormAdyen_asyncToGenerator(runtime_default().mark(function _callee() {
                var ref, ref17, ref18, linkLocal, data, payment, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, gaParams, cleanGAParams, ref39, ref40, ref41, checkout;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            if (!(cgu && retractAgree && holderName)) {
                                _ctx.next = 47;
                                break;
                            }
                            setCguError(false);
                            setPaymentProcessing(true);
                            trackEvent({
                                category: 'Payment',
                                action: "User click on pay button"
                            });
                            if (!isCardValidAdyen) {
                                _ctx.next = 45;
                                break;
                            }
                            ;
                            _ctx.next = 8;
                            return createCheckoutPayment1(cart.item.tokenValue);
                        case 8:
                            linkLocal = router.locale ? "/".concat(router.locale) : '';
                            data = {
                                email: localStorage.getItem('email'),
                                userAgent: userAgent,
                                card: {
                                    number: adyenCardData.encryptedCardNumber,
                                    expiryMonth: adyenCardData.encryptedExpiryMonth,
                                    cvc: adyenCardData.encryptedExpiryYear,
                                    expiryYear: adyenCardData.encryptedSecurityCode,
                                    type: adyenCardData.type,
                                    holderName: holderName
                                },
                                returnUrl: window.location.origin,
                                frontSuccessPaymentUrl: "".concat(window.location.origin).concat(linkLocal, "/confirmation"),
                                frontFailPaymentUrl: "".concat(window.location.origin).concat(linkLocal, "/payment?error_3D=true"),
                                swik_id: swikId
                            };
                            if (((ref17 = cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.shipments[0].method) === null || ref17 === void 0 ? void 0 : ref17.type) !== 'HOME_DELIVERY' && typeof localStorage.getItem('rmsParcelShopId') !== 'undefined' && localStorage.getItem('rmsParcelShopId') !== null) {
                                data['parcelShopId'] = localStorage.getItem('rmsParcelShopId');
                            }
                            payment = null;
                            if (constants/* isSubscription */.Nn) {
                                _ctx.next = 18;
                                break;
                            }
                            _ctx.next = 15;
                            return postDadPayment1(data, cart.item.tokenValue);
                        case 15:
                            payment = _ctx.sent;
                            _ctx.next = 21;
                            break;
                        case 18:
                            _ctx.next = 20;
                            return postSubPayment1(data, cart.item.tokenValue);
                        case 20:
                            payment = _ctx.sent;
                        case 21:
                            if (!(payment.paymentResult === 'Order completed')) {
                                _ctx.next = 36;
                                break;
                            }
                            ;
                            setPaymentProcessing(false);
                            setPaymentFailed(false);
                            _ctx.next = 27;
                            return pushInstruction('trackEcommerceOrder', cart === null || cart === void 0 ? void 0 : (ref19 = cart.item) === null || ref19 === void 0 ? void 0 : ref19.tokenValue, (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref20 = cart.item) === null || ref20 === void 0 ? void 0 : (ref21 = ref20.totals) === null || ref21 === void 0 ? void 0 : ref21.total), (0,utils/* numberToPrice */.e8)((cart === null || cart === void 0 ? void 0 : (ref22 = cart.item) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.totals) === null || ref23 === void 0 ? void 0 : ref23.total) - (cart === null || cart === void 0 ? void 0 : (ref24 = cart.item) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.totals) === null || ref25 === void 0 ? void 0 : ref25.shipping)), (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref26 = cart.item) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.totals) === null || ref27 === void 0 ? void 0 : ref27.taxes), (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref28 = cart.item) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.totals) === null || ref29 === void 0 ? void 0 : ref29.shipping), (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref30 = cart.item) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.totals) === null || ref31 === void 0 ? void 0 : ref31.promotion) // discount (Optional) – Integer/Float/Boolean – Discount offered? Default to false. Otherwise, you should include a numeric value.
                            );
                        case 27:
                            gaParams = {
                                transaction_id: cart === null || cart === void 0 ? void 0 : (ref32 = cart.item) === null || ref32 === void 0 ? void 0 : ref32.tokenValue,
                                currency: cart.item.currency,
                                value: (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref33 = cart.item) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.totals) === null || ref34 === void 0 ? void 0 : ref34.total),
                                tax: (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref35 = cart.item) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.totals) === null || ref36 === void 0 ? void 0 : ref36.taxes),
                                shipping: (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref37 = cart.item) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.totals) === null || ref38 === void 0 ? void 0 : ref38.shipping),
                                items: cart.item.items.map(function(param) {
                                    var product = param.product, quantity = param.quantity, total = param.total;
                                    var firstVariant = Object.values(product === null || product === void 0 ? void 0 : product.variants)[0];
                                    var _obj;
                                    return _obj = {}, PaymentFormAdyen_defineProperty(_obj, 'item_name', product.name), PaymentFormAdyen_defineProperty(_obj, 'item_id', gtag/* isChalhoub */.LP ? firstVariant.sku : product.code), PaymentFormAdyen_defineProperty(_obj, 'item_variant', gtag/* isChalhoub */.LP && firstVariant.code), PaymentFormAdyen_defineProperty(_obj, "price", (0,utils/* numberToPrice */.e8)(total)), PaymentFormAdyen_defineProperty(_obj, "quantity", quantity), _obj;
                                })
                            };
                            cleanGAParams = (0,gtag/* clearItemVariantFromGAParamsIfNotChalhoub */.o9)(gaParams);
                            gtag/* tracker */.ap(base/* GAEvent.PURCHASE */.gB.PURCHASE, cleanGAParams);
                            (0,gtag/* safeDataLayerPush */.Kx)((0,gtag/* getPaymentInfoGtmData */.yo)(cart, coupon, 'adyen'));
                            // Meta Pixel: Purchase event with amount and currency
                            if ( true && typeof window.fbq === 'function') {
                                ;
                                window.fbq('track', 'Purchase', {
                                    value: (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref39 = cart.item) === null || ref39 === void 0 ? void 0 : (ref40 = ref39.totals) === null || ref40 === void 0 ? void 0 : ref40.total),
                                    currency: cart === null || cart === void 0 ? void 0 : (ref41 = cart.item) === null || ref41 === void 0 ? void 0 : ref41.currency
                                });
                            }
                            _ctx.next = 34;
                            return router.push('/confirmation');
                        case 34:
                            _ctx.next = 45;
                            break;
                        case 36:
                            if (!((payment === null || payment === void 0 ? void 0 : (ref18 = payment.paymentResult) === null || ref18 === void 0 ? void 0 : ref18.resultCode) === 'RedirectShopper')) {
                                _ctx.next = 44;
                                break;
                            }
                            localStorage.setItem('Payment type', '3dSecure');
                            _ctx.next = 40;
                            return (0,dist_es/* default */.Z)(configuration);
                        case 40:
                            checkout = _ctx.sent;
                            checkout.createFromAction(payment.paymentResult.action).mount('#customCard-container');
                            _ctx.next = 45;
                            break;
                        case 44:
                            {
                                setError(t('texts:funnel:payment:error'));
                                setPaymentProcessing(false);
                            }
                        case 45:
                            _ctx.next = 48;
                            break;
                        case 47:
                            {
                                setCguError(true);
                            }
                        case 48:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function asyncFunc() {
                return _ref.apply(this, arguments);
            };
        }();
        asyncFunc();
    };
    (0,react.useEffect)(function() {
        if (process.env.USE_ADYEN && (cart === null || cart === void 0 ? void 0 : cart.item)) {
            var asyncFunc = function() {
                var _ref = PaymentFormAdyen_asyncToGenerator(runtime_default().mark(function _callee() {
                    var checkout;
                    return runtime_default().wrap(function _callee$(_ctx) {
                        while(1)switch(_ctx.prev = _ctx.next){
                            case 0:
                                _ctx.next = 2;
                                return (0,dist_es/* default */.Z)(configuration);
                            case 2:
                                checkout = _ctx.sent;
                                // Create an instance of Drop-in and mount it to the container you created.
                                checkout.create('securedfields', {
                                    // Optional configuration
                                    type: 'card',
                                    brands: [
                                        'mc',
                                        'visa',
                                        'amex',
                                        'bcmc',
                                        'maestro'
                                    ],
                                    styles: {
                                        base: {
                                            lineHeight: theme.typography.body2.lineHeight,
                                            fontFamily: "".concat(theme.typography.fontFamily),
                                            fontSize: '14px',
                                            color: theme.typography.body1.color,
                                            WebkitAppearance: 'none'
                                        },
                                        label: {
                                            marginTop: theme.spacing(1),
                                            display: 'block'
                                        },
                                        error: {
                                            WebkitAppearance: 'none',
                                            color: theme.palette.error.main,
                                            background: theme.extraColors.greyLight
                                        },
                                        validated: {
                                            WebkitAppearance: 'none',
                                            color: theme.palette.success.main,
                                            background: theme.extraColors.greyLight
                                        },
                                        placeholder: {
                                            color: theme.typography.body1.color,
                                            fontWeight: 400,
                                            opacity: 0.75
                                        }
                                    }
                                }).mount('#customCard-container');
                            case 4:
                            case "end":
                                return _ctx.stop();
                        }
                    }, _callee);
                //}
                }));
                return function asyncFunc() {
                    return _ref.apply(this, arguments);
                };
            }();
            asyncFunc();
        }
    }, [
        cart
    ]);
    var _obj1;
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.mainContainer,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: classes.root,
                id: 'root',
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        id: "customCard-container",
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: classes.label,
                                        component: 'span',
                                        variant: 'body1',
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: settings === null || settings === void 0 ? void 0 : settings.card_number,
                                            defaultText: t('texts:general:card_number')
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                        "data-cse": "encryptedCardNumber",
                                        className: (0,clsx_m/* default */.Z)(classes.input, 'input--ayden')
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes.row,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                className: classes.label,
                                                component: 'span',
                                                variant: 'body1',
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: settings === null || settings === void 0 ? void 0 : settings.expiry_date,
                                                    defaultText: t('texts:general:expiry_date')
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                "data-cse": "encryptedExpiryDate",
                                                className: (0,clsx_m/* default */.Z)(classes.input, 'input--ayden')
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                className: classes.label,
                                                component: 'span',
                                                variant: 'body1',
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    asText: true,
                                                    data: settings === null || settings === void 0 ? void 0 : settings.cvc_code,
                                                    defaultText: t('texts:general:cvc_code')
                                                })
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                "data-cse": "encryptedSecurityCode",
                                                className: (0,clsx_m/* default */.Z)(classes.input, 'input--ayden')
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("label", {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        className: classes.label,
                                        component: 'span',
                                        variant: 'body1',
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: settings === null || settings === void 0 ? void 0 : settings.cvc_code,
                                            defaultText: t('texts:general:holder_name')
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("input", {
                                        type: "text",
                                        name: "holderName",
                                        className: (0,clsx_m/* default */.Z)(classes.input, classes.marginBottom, 'input--ayden'),
                                        placeholder: t('texts:general:holder_name'),
                                        value: holderName,
                                        required: true,
                                        onChange: function() {
                                            return handleHolderName(event);
                                        }
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                    checked: cgu,
                    onChange: changeCgu,
                    name: "checkedA",
                    "data-testid": 'cgu_check'
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: 'body2',
                    component: 'span',
                    className: commonClasses.cgu,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        data: text === null || text === void 0 ? void 0 : text.cgu,
                        defaultText: t('texts:funnel:payment:cgu')
                    })
                })
            }),
            registeredStoreSlug && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: 'body2',
                component: 'span',
                className: commonClasses.customCgl,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: "/pages/cgl-".concat(registeredStoreSlug),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            data: text === null || text === void 0 ? void 0 : text.custom_cgu_link,
                            asText: true,
                            defaultText: t('texts:funnel:payment:custom_cgu_link')
                        })
                    })
                })
            }),
            isRetractation && retractReady && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                    checked: retractAgree,
                    onChange: changeRetract,
                    name: "retractation",
                    "data-testid": 'retract_check'
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: 'body2',
                    component: 'span',
                    className: commonClasses.cgu,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        data: text === null || text === void 0 ? void 0 : text.retractation_agreement,
                        defaultText: t('texts:funnel:payment:retractation_agreement')
                    })
                })
            }),
            paymentFailed && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                color: 'error',
                variant: 'body1',
                align: 'center',
                children: error
            }),
            cguError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                color: 'secondary',
                variant: 'body1',
                align: 'center',
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                    asText: true,
                    data: text === null || text === void 0 ? void 0 : text.cgu_error,
                    defaultText: t('texts:funnel:payment:cgu_error')
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: commonClasses.centeredButton,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                    disabled: !cgu || !retractAgree || !isCardValidAdyen || paymentProcessing || holderName === '' || disabled,
                    className: (0,clsx_m/* default */.Z)(commonClasses.submit, (_obj1 = {}, PaymentFormAdyen_defineProperty(_obj1, commonClasses.inProgress, paymentProcessing), PaymentFormAdyen_defineProperty(_obj1, 'payment-form__submit-progress', paymentProcessing), _obj1), 'payment-form__submit'),
                    variant: "contained",
                    "data-testid": "paymentSubmit",
                    color: "primary",
                    onClick: handleAdyenOrder,
                    type: "submit",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                            className: paymentProcessing ? commonClasses.hide : commonClasses.show,
                            children: (0,CMSText/* prismicText */.yz)(text === null || text === void 0 ? void 0 : text.pay, t('texts:funnel:pay'))
                        }),
                        paymentProcessing && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
                    ]
                })
            })
        ]
    }));
};
var PaymentFormAdyen_mapStateToProps = function(state) {
    return {
        cart: state.cart
    };
};
var PaymentFormAdyen_mapDispatchToProps = {
    postDadPayment: payment_postDadPayment,
    postSubPayment: payment_postSubPayment,
    createCheckoutPayment: checkout/* createCheckoutPayment */.dG
};
/* harmony default export */ var PaymentForm_PaymentFormAdyen = ((0,es/* connect */.$j)(PaymentFormAdyen_mapStateToProps, PaymentFormAdyen_mapDispatchToProps)(PaymentFormAdyen));

// EXTERNAL MODULE: ./utils/funnel.ts
var utils_funnel = __webpack_require__(58913);
// EXTERNAL MODULE: ./hooks/useInformationSkipped.ts
var useInformationSkipped = __webpack_require__(25630);
// EXTERNAL MODULE: ./components/Funnel/FunnelAside.tsx
var FunnelAside = __webpack_require__(60291);
// EXTERNAL MODULE: ./hooks/useCart.ts
var useCart = __webpack_require__(19789);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Box/Box.js + 14 modules
var Box = __webpack_require__(14903);
// EXTERNAL MODULE: ./node_modules/@paypal/react-paypal-js/dist/esm/react-paypal-js.js
var react_paypal_js = __webpack_require__(75021);
// EXTERNAL MODULE: ./node_modules/@datadog/browser-logs/esm/entries/main.js + 16 modules
var main = __webpack_require__(67020);
// EXTERNAL MODULE: ./redux/services/products.ts
var products = __webpack_require__(83260);
;// CONCATENATED MODULE: ./components/PaymentForm/PaymentPaypal.tsx























function PaymentPaypal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function PaymentPaypal_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                PaymentPaypal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                PaymentPaypal_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function PaymentPaypal_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            PaymentPaypal_defineProperty(target, key, source[key]);
        });
    }
    return target;
}
var PaymentPaypal = function(param1) {
    var cart = param1.cart, doc = param1.doc, postFinalizeDadPayment1 = param1.postFinalizeDadPayment, createCheckoutPayment1 = param1.createCheckoutPayment, startLeasingDate = param1.startLeasingDate, coupon = param1.coupon, stores = param1.stores;
    var ref13, ref1, ref2, ref3, ref4;
    var commonClasses = (0,CardForm_style/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref5 = (0,react.useState)(false), retractReady = ref5[0], setRetractReady = ref5[1];
    var ref6 = (0,react.useState)(false), retractAgree = ref6[0], setRetractAgree = ref6[1];
    var ref7 = (0,react.useState)(false), cgu = ref7[0], setCgu = ref7[1];
    var ref8 = (0,react.useState)(''), error1 = ref8[0], setError = ref8[1];
    /** Cart lines that exceed current RMS availability */ var ref9 = (0,react.useState)(null), insufficientStockProducts = ref9[0], setInsufficientStockProducts = ref9[1];
    /** Network / invalid response / RMS error — not a “stock shortage”, but payment stays blocked */ var ref10 = (0,react.useState)(false), availabilityCheckFailed = ref10[0], setAvailabilityCheckFailed = ref10[1];
    var isRetractation = doc === null || doc === void 0 ? void 0 : (ref13 = doc.data) === null || ref13 === void 0 ? void 0 : ref13.enable_retractation_agreement;
    var retractingDays = doc === null || doc === void 0 ? void 0 : (ref1 = doc.data) === null || ref1 === void 0 ? void 0 : ref1.retractation_duration;
    var ref11 = (0,useMatomo/* default */.Z)(), trackEvent = ref11.trackEvent, pushInstruction = ref11.pushInstruction;
    var ref12 = (0,react.useState)(''), registeredStoreSlug = ref12[0], setRegisteredStoreSlug = ref12[1];
    /** PayPal onError may run before React commits state from createOrder */ var prePaypalPaymentBlockedRef = (0,react.useRef)(false);
    var isPaypalBlocked = insufficientStockProducts !== null || availabilityCheckFailed;
    (0,react.useEffect)(function() {
        var ref;
        typeof localStorage !== 'undefined' && setRegisteredStoreSlug((ref = JSON.parse(localStorage.getItem('selectedStore'))) === null || ref === void 0 ? void 0 : ref.slug);
    }, []);
    hook_useRetractationEffect({
        startLeasingDate: startLeasingDate,
        isRetractation: isRetractation,
        retractingDays: retractingDays,
        setRetractReady: setRetractReady,
        setRetractAgree: setRetractAgree
    });
    var changeRetract = function() {
        setRetractAgree(!retractAgree);
    };
    var changeCgu = function() {
        setCgu(!cgu);
    };
    var checkAvailabilityBeforePaypal = function() {
        var _ref = PaymentPaypal_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref17, email, ref14, ref15, ref16, cartPuids, uniquePuids, stockResponse, unavailablePuids, outOfStockNames, warehouseId, SKUArray, data, fromDate, toDate, stockResponse1, outOfStockNames1;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (cart === null || cart === void 0 ? void 0 : (ref17 = cart.item) === null || ref17 === void 0 ? void 0 : ref17.items) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            ok: true
                        });
                    case 3:
                        email = typeof localStorage !== 'undefined' ? localStorage.getItem('email') : null;
                        if (email) {
                            _ctx.next = 6;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            ok: false,
                            reason: 'availability_check_unavailable'
                        });
                    case 6:
                        _ctx.prev = 6;
                        ;
                        cartPuids = [];
                        cart.item.items.forEach(function(item) {
                            var ref;
                            (ref = item.units) === null || ref === void 0 ? void 0 : ref.forEach(function(unit) {
                                if (unit === null || unit === void 0 ? void 0 : unit.puid) {
                                    cartPuids.push({
                                        puid: unit.puid,
                                        productName: item.product.name
                                    });
                                }
                            });
                        });
                        if (!(cartPuids.length > 0)) {
                            _ctx.next = 22;
                            break;
                        }
                        uniquePuids = Array.from(new Set(cartPuids.map(function(entry) {
                            return entry.puid;
                        })));
                        _ctx.next = 14;
                        return (0,products/* getUniqueProductStock */.BA)(uniquePuids);
                    case 14:
                        stockResponse = _ctx.sent;
                        if (Array.isArray(stockResponse)) {
                            _ctx.next = 17;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            ok: false,
                            reason: 'availability_check_unavailable'
                        });
                    case 17:
                        unavailablePuids = new Set(stockResponse.filter(function(item) {
                            return item.available === false;
                        }).map(function(item) {
                            return item.puid;
                        }));
                        outOfStockNames = Array.from(new Set(cartPuids.filter(function(entry) {
                            return unavailablePuids.has(entry.puid);
                        }).map(function(entry) {
                            return entry.productName;
                        })));
                        if (!(outOfStockNames.length > 0)) {
                            _ctx.next = 21;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            ok: false,
                            reason: 'insufficient_stock',
                            products: outOfStockNames
                        });
                    case 21:
                        return _ctx.abrupt("return", {
                            ok: true
                        });
                    case 22:
                        warehouseId = stores === null || stores === void 0 ? void 0 : (ref14 = stores.selectedStore) === null || ref14 === void 0 ? void 0 : ref14.warehouseId;
                        SKUArray = cart.item.items.map(function(item) {
                            return item.product.variants[0].sku;
                        });
                        data = {
                            lizeeSKUs: SKUArray,
                            email: email
                        };
                        if (((ref15 = cart.item) === null || ref15 === void 0 ? void 0 : ref15.startLeasingDate) && ((ref16 = cart.item) === null || ref16 === void 0 ? void 0 : ref16.endLeasingDate) && !constants/* isSubscription */.Nn) {
                            fromDate = dayjs_min_default()(cart.item.startLeasingDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
                            toDate = dayjs_min_default()(cart.item.endLeasingDate, 'DD/MM/YYYY').format('YYYY-MM-DD');
                            data = _objectSpread({}, data, {
                                from: fromDate,
                                to: toDate
                            });
                        }
                        _ctx.next = 28;
                        return (0,products/* getStock */.K5)(data, warehouseId);
                    case 28:
                        stockResponse1 = _ctx.sent;
                        if (Array.isArray(stockResponse1)) {
                            _ctx.next = 31;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            ok: false,
                            reason: 'availability_check_unavailable'
                        });
                    case 31:
                        outOfStockNames1 = [];
                        cart.item.items.forEach(function(item) {
                            var availability = (0,utils/* checkStockQuantityByItemType */.qe)({
                                stockBasket: stockResponse1
                            }, item.product.variants[0], item.type, 'basket');
                            if (item.quantity > (availability !== null && availability !== void 0 ? availability : 0)) {
                                outOfStockNames1.push(item.product.name);
                            }
                        });
                        if (!(outOfStockNames1.length > 0)) {
                            _ctx.next = 35;
                            break;
                        }
                        return _ctx.abrupt("return", {
                            ok: false,
                            reason: 'insufficient_stock',
                            products: outOfStockNames1
                        });
                    case 35:
                        return _ctx.abrupt("return", {
                            ok: true
                        });
                    case 38:
                        _ctx.prev = 38;
                        _ctx.t0 = _ctx["catch"](6);
                        main/* datadogLogs.logger.error */.fy.logger.error('PayPal pre-payment availability check failed', _ctx.t0);
                        return _ctx.abrupt("return", {
                            ok: false,
                            reason: 'availability_check_unavailable'
                        });
                    case 42:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    6,
                    38
                ]
            ]);
        }));
        return function checkAvailabilityBeforePaypal() {
            return _ref.apply(this, arguments);
        };
    }();
    var createOrder = function() {
        var _ref = PaymentPaypal_asyncToGenerator(runtime_default().mark(function _callee(data, actions) {
            var ref, ref18, ref19, availability;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        prePaypalPaymentBlockedRef.current = false;
                        setInsufficientStockProducts(null);
                        setAvailabilityCheckFailed(false);
                        _ctx.next = 6;
                        return checkAvailabilityBeforePaypal();
                    case 6:
                        availability = _ctx.sent;
                        if (!(availability.ok === false)) {
                            _ctx.next = 11;
                            break;
                        }
                        prePaypalPaymentBlockedRef.current = true;
                        if (availability.reason === 'insufficient_stock') {
                            setInsufficientStockProducts(availability.products);
                        } else {
                            setAvailabilityCheckFailed(true);
                        }
                        throw new Error('PayPal pre-payment blocked');
                    case 11:
                        _ctx.next = 13;
                        return actions.order.create({
                            intent: 'CAPTURE',
                            purchase_units: [
                                {
                                    amount: {
                                        currency_code: cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.currency,
                                        value: ((cart === null || cart === void 0 ? void 0 : (ref18 = cart.item) === null || ref18 === void 0 ? void 0 : (ref19 = ref18.totals) === null || ref19 === void 0 ? void 0 : ref19.total) / 100).toFixed(2)
                                    }
                                }, 
                            ]
                        });
                    case 13:
                        return _ctx.abrupt("return", _ctx.sent);
                    case 14:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function createOrder(data, actions) {
            return _ref.apply(this, arguments);
        };
    }();
    var onError = function(error) {
        if (prePaypalPaymentBlockedRef.current || isPaypalBlocked) {
            prePaypalPaymentBlockedRef.current = false;
            return;
        }
        setError('An error occured, please try again');
        main/* datadogLogs.logger.error */.fy.logger.error('An error occured, please try again', error);
    };
    var onApprove = function() {
        var _ref = PaymentPaypal_asyncToGenerator(runtime_default().mark(function _callee(data, actions) {
            var ref, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, availability, body, gaParams, cleanGAParams, ref41, ref42, ref43, captureResponse;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        prePaypalPaymentBlockedRef.current = false;
                        setInsufficientStockProducts(null);
                        setAvailabilityCheckFailed(false);
                        _ctx.next = 6;
                        return checkAvailabilityBeforePaypal();
                    case 6:
                        availability = _ctx.sent;
                        if (!(availability.ok === false)) {
                            _ctx.next = 10;
                            break;
                        }
                        if (availability.reason === 'insufficient_stock') {
                            setInsufficientStockProducts(availability.products);
                        } else {
                            setAvailabilityCheckFailed(true);
                        }
                        return _ctx.abrupt("return");
                    case 10:
                        trackEvent({
                            category: 'Payment',
                            action: "User click on Paypal pay button"
                        });
                        body = {
                            email: localStorage.getItem('email'),
                            paymentId: data.orderID
                        };
                        if (((ref20 = cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.shipments[0].method) === null || ref20 === void 0 ? void 0 : ref20.type) !== 'HOME_DELIVERY' && typeof localStorage.getItem('rmsParcelShopId') !== 'undefined' && localStorage.getItem('rmsParcelShopId') !== null) {
                            body['parcelShopId'] = localStorage.getItem('rmsParcelShopId');
                        }
                        pushInstruction('trackEcommerceOrder', cart === null || cart === void 0 ? void 0 : (ref21 = cart.item) === null || ref21 === void 0 ? void 0 : ref21.tokenValue, (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref22 = cart.item) === null || ref22 === void 0 ? void 0 : (ref23 = ref22.totals) === null || ref23 === void 0 ? void 0 : ref23.total), (0,utils/* numberToPrice */.e8)((cart === null || cart === void 0 ? void 0 : (ref24 = cart.item) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.totals) === null || ref25 === void 0 ? void 0 : ref25.total) - (cart === null || cart === void 0 ? void 0 : (ref26 = cart.item) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.totals) === null || ref27 === void 0 ? void 0 : ref27.shipping)), (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref28 = cart.item) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.totals) === null || ref29 === void 0 ? void 0 : ref29.taxes), (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref30 = cart.item) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.totals) === null || ref31 === void 0 ? void 0 : ref31.shipping), (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref32 = cart.item) === null || ref32 === void 0 ? void 0 : (ref33 = ref32.totals) === null || ref33 === void 0 ? void 0 : ref33.promotion) // discount (Optional) – Integer/Float/Boolean – Discount offered? Default to false. Otherwise, you should include a numeric value.
                        );
                        gaParams = {
                            transaction_id: cart === null || cart === void 0 ? void 0 : (ref34 = cart.item) === null || ref34 === void 0 ? void 0 : ref34.tokenValue,
                            currency: cart.item.currency,
                            value: (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref35 = cart.item) === null || ref35 === void 0 ? void 0 : (ref36 = ref35.totals) === null || ref36 === void 0 ? void 0 : ref36.total),
                            tax: (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref37 = cart.item) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.totals) === null || ref38 === void 0 ? void 0 : ref38.taxes),
                            shipping: (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref39 = cart.item) === null || ref39 === void 0 ? void 0 : (ref40 = ref39.totals) === null || ref40 === void 0 ? void 0 : ref40.shipping),
                            items: cart.item.items.map(function(param) {
                                var product = param.product, quantity = param.quantity, total = param.total;
                                var firstVariant = Object.values(product === null || product === void 0 ? void 0 : product.variants)[0];
                                var _obj;
                                return _obj = {}, PaymentPaypal_defineProperty(_obj, 'item_name', product.name), PaymentPaypal_defineProperty(_obj, 'item_id', gtag/* isChalhoub */.LP ? firstVariant.sku : product.code), PaymentPaypal_defineProperty(_obj, 'item_variant', gtag/* isChalhoub */.LP && firstVariant.code), PaymentPaypal_defineProperty(_obj, "price", (0,utils/* numberToPrice */.e8)(total)), PaymentPaypal_defineProperty(_obj, "quantity", quantity), _obj;
                            })
                        };
                        cleanGAParams = (0,gtag/* clearItemVariantFromGAParamsIfNotChalhoub */.o9)(gaParams);
                        gtag/* tracker */.ap(base/* GAEvent.PURCHASE */.gB.PURCHASE, cleanGAParams);
                        (0,gtag/* safeDataLayerPush */.Kx)((0,gtag/* getPaymentInfoGtmData */.yo)(cart, coupon, 'paypal'));
                        // Meta Pixel: Purchase event with amount and currency
                        if ( true && typeof window.fbq === 'function') {
                            ;
                            window.fbq('track', 'Purchase', {
                                value: (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref41 = cart.item) === null || ref41 === void 0 ? void 0 : (ref42 = ref41.totals) === null || ref42 === void 0 ? void 0 : ref42.total),
                                currency: cart === null || cart === void 0 ? void 0 : (ref43 = cart.item) === null || ref43 === void 0 ? void 0 : ref43.currency
                            });
                        }
                        _ctx.prev = 19;
                        _ctx.next = 22;
                        return createCheckoutPayment1(cart.item.tokenValue);
                    case 22:
                        _ctx.next = 24;
                        return actions.order.capture();
                    case 24:
                        captureResponse = _ctx.sent;
                        main/* datadogLogs.logger.info */.fy.logger.info('Payment Successful', captureResponse);
                        if (!(captureResponse && (captureResponse === null || captureResponse === void 0 ? void 0 : captureResponse.status) === 'COMPLETED')) {
                            _ctx.next = 41;
                            break;
                        }
                        body['paymentResponse'] = captureResponse;
                        _ctx.prev = 28;
                        _ctx.next = 31;
                        return postFinalizeDadPayment1(body, cart.item.tokenValue);
                    case 31:
                        _ctx.next = 33;
                        return router.push('/confirmation');
                    case 33:
                        _ctx.next = 39;
                        break;
                    case 35:
                        _ctx.prev = 35;
                        _ctx.t0 = _ctx["catch"](28);
                        setError('An error occured, please try again');
                        main/* datadogLogs.logger.error */.fy.logger.error('Error during payment finalization', _ctx.t0);
                    case 39:
                        _ctx.next = 42;
                        break;
                    case 41:
                        {
                            setError('An error occured, please try again');
                            main/* datadogLogs.logger.error */.fy.logger.error('Failed to capture order', captureResponse);
                        }
                    case 42:
                        _ctx.next = 48;
                        break;
                    case 44:
                        _ctx.prev = 44;
                        _ctx.t1 = _ctx["catch"](19);
                        setError('An error occured, please try again');
                        main/* datadogLogs.logger.error */.fy.logger.error('Error capturing order', _ctx.t1);
                    case 48:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    19,
                    44
                ],
                [
                    28,
                    35
                ]
            ]);
        }));
        return function onApprove(data, actions) {
            return _ref.apply(this, arguments);
        };
    }();
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            registeredStoreSlug && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: 'body2',
                component: 'span',
                className: commonClasses.customCgl,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                    href: "/pages/cgl-".concat(registeredStoreSlug),
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            data: doc === null || doc === void 0 ? void 0 : (ref2 = doc.data) === null || ref2 === void 0 ? void 0 : ref2.custom_cgu_link,
                            asText: true,
                            defaultText: t('texts:funnel:payment:custom_cgu_link')
                        })
                    })
                })
            }),
            isRetractation && retractReady && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                    checked: retractAgree,
                    onChange: changeRetract,
                    name: "retractation",
                    "data-testid": 'retract_check'
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: 'body2',
                    component: 'span',
                    className: commonClasses.cgu,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        data: doc === null || doc === void 0 ? void 0 : (ref3 = doc.data) === null || ref3 === void 0 ? void 0 : ref3.retractation_agreement,
                        defaultText: t('texts:funnel:payment:retractation_agreement')
                    })
                })
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(react_paypal_js/* PayPalButtons */.ch, {
                createOrder: createOrder,
                onApprove: onApprove,
                onError: onError,
                style: {
                    layout: 'horizontal',
                    tagline: false,
                    label: 'pay'
                },
                disabled: !cgu || !retractAgree || isPaypalBlocked
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                    checked: cgu,
                    onChange: changeCgu,
                    name: "checkedA",
                    "data-testid": 'cgu_check'
                }),
                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: 'body2',
                    component: 'span',
                    className: commonClasses.cgu,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                        data: doc === null || doc === void 0 ? void 0 : (ref4 = doc.data) === null || ref4 === void 0 ? void 0 : ref4.cgu,
                        defaultText: t('texts:funnel:payment:cgu')
                    })
                })
            }),
            insufficientStockProducts && /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                in: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    textAlign: "center",
                    mb: 2,
                    "data-testid": "paypal-insufficient-stock",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            component: "p",
                            gutterBottom: true,
                            color: "error",
                            children: t('texts:funnel:payment:errors:stock_error_intro')
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            component: "ul",
                            style: {
                                margin: '8px 0 12px',
                                paddingLeft: '1.25rem',
                                display: 'inline-block',
                                textAlign: 'left'
                            },
                            children: insufficientStockProducts.map(function(name, index) {
                                /*#__PURE__*/ return (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                    component: "li",
                                    variant: "body2",
                                    color: "error",
                                    style: {
                                        marginBottom: 4
                                    },
                                    children: name
                                }, "".concat(name, "-").concat(index));
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "body2",
                            component: "p",
                            color: "error",
                            children: t('texts:funnel:payment:errors:stock_error_footer')
                        })
                    ]
                })
            }),
            availabilityCheckFailed && /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                in: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    textAlign: "center",
                    mb: 2,
                    "data-testid": "paypal-availability-check-failed",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        component: "p",
                        color: "error",
                        children: t('texts:funnel:payment:errors:availability_check_failed')
                    })
                })
            }),
            error1 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Fade/* default */.Z, {
                in: true,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    color: "error",
                    variant: 'body1',
                    align: 'center',
                    children: error1
                })
            })
        ]
    }));
};
var PaymentPaypal_mapStateToProps = function(state) {
    return {
        cart: state.cart,
        stores: state.stores
    };
};
var PaymentPaypal_mapDispatchToProps = {
    postFinalizeDadPayment: payment_postFinalizeDadPayment,
    createCheckoutPayment: checkout/* createCheckoutPayment */.dG,
    getCheckout: checkout/* getCheckout */.Om
};
/* harmony default export */ var PaymentForm_PaymentPaypal = ((0,es/* connect */.$j)(PaymentPaypal_mapStateToProps, PaymentPaypal_mapDispatchToProps)(PaymentPaypal));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/RadioGroup/RadioGroup.js + 1 modules
var RadioGroup = __webpack_require__(37661);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Accordion/Accordion.js
var Accordion = __webpack_require__(36939);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/AccordionSummary/AccordionSummary.js
var AccordionSummary = __webpack_require__(50743);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Radio/Radio.js + 4 modules
var Radio = __webpack_require__(32340);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/AccordionDetails/AccordionDetails.js
var AccordionDetails = __webpack_require__(61201);
// EXTERNAL MODULE: ./node_modules/next/image.js
var next_image = __webpack_require__(25675);
// EXTERNAL MODULE: ./node_modules/@mui/icons-material/CreditCard.js
var CreditCard = __webpack_require__(54927);
;// CONCATENATED MODULE: ./components/PaymentForm/PaymentAccordion.tsx








var PaymentAccordion_useStyles = (0,makeStyles/* default */.Z)(function() {
    return {
        root: {
            margin: '15px 0'
        },
        formControlLabel: {
            width: '100%'
        },
        accordionSummaryLabel: {
            width: '100%'
        },
        accordionTitle: {
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between'
        },
        title: {
            width: '100%'
        },
        accordionContent: {
            paddingLeft: 12,
            paddingRight: 0,
            '&>.MuiAccordionSummary-content': {
                justifyContent: 'space-between',
                alignItems: 'center',
                '&.Mui-expanded': {
                    margin: 0
                }
            },
            '& .MuiFormControlLabel-root': {
                display: 'flex',
                width: '100%'
            },
            '& .MuiFormControlLabel-label': {
                flexGrow: 1,
                '& .MuiTypography-root': {
                    lineHeight: 1
                }
            }
        },
        tagLineWithIcon: {
            display: 'flex',
            justifyContent: 'space-between'
        },
        icon: {
            width: '20px!important'
        },
        cardTagline: {
            display: 'flex',
            alignItems: 'center'
        },
        cardIcons: {
            display: 'flex',
            alignItems: 'center',
            gap: 4,
            '& span': {
                width: '20px!important'
            }
        }
    };
});
var PaymentAccordion = function(param) {
    var cardComponent = param.cardComponent, paypalComponent = param.paypalComponent;
    var classes = PaymentAccordion_useStyles();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var ref = (0,react.useState)(''), selectedPayment = ref[0], setSelectedPayment = ref[1];
    var handleChange = function(event) {
        setSelectedPayment(event.target.value);
    };
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)(RadioGroup/* default */.Z, {
        value: selectedPayment,
        onChange: handleChange,
        className: classes.root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                expanded: selectedPayment === constants/* PAYMENT_ACCORDION.CARD */.OV.CARD,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                        "aria-controls": "card-content",
                        id: "card-header",
                        className: classes.accordionContent,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                            value: "card",
                            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                color: "primary",
                                className: 'carrier-accordion__radio',
                                "aria-label": "Credit card"
                            }),
                            className: classes.formControlLabel,
                            classes: {
                                label: classes.accordionSummaryLabel
                            },
                            label: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes.accordionTitle,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                    className: classes.title,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            children: t('texts:funnel:payment:payment_accordion:card_title')
                                        }),
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                            className: classes.tagLineWithIcon,
                                            children: [
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: "body2",
                                                    className: classes.cardTagline,
                                                    children: t('texts:funnel:payment:payment_accordion:card_tagline')
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: classes.cardIcons,
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                                            src: '/icon-mastercard.svg',
                                                            alt: 'mastercard',
                                                            width: 20,
                                                            height: 20,
                                                            className: (0,clsx_m/* default */.Z)('payment-accordion__card-icon', classes.icon)
                                                        }),
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(CreditCard/* default */.Z, {
                                                            className: 'payment-accordion__card-icon'
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                })
                            }),
                            onClick: function(event) {
                                return event.stopPropagation();
                            },
                            onFocus: function(event) {
                                return event.stopPropagation();
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            children: cardComponent
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                expanded: selectedPayment === constants/* PAYMENT_ACCORDION.PAYPAL */.OV.PAYPAL,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                        "aria-controls": "paypal-content",
                        id: "paypal-header",
                        className: classes.accordionContent,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                            value: "paypal",
                            control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default */.Z, {
                                color: "primary",
                                className: 'carrier-accordion__radio',
                                "aria-label": "Paypal"
                            }),
                            className: classes.formControlLabel,
                            classes: {
                                label: classes.accordionSummaryLabel
                            },
                            label: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes.accordionTitle,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                        children: t('texts:funnel:payment:payment_accordion:paypal_title')
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(next_image["default"], {
                                        src: '/icon-paypal.svg',
                                        alt: 'paypal',
                                        width: 28,
                                        height: 20,
                                        className: 'payment-accordion__card-icon'
                                    })
                                ]
                            }),
                            onClick: function(event) {
                                return event.stopPropagation();
                            },
                            onFocus: function(event) {
                                return event.stopPropagation();
                            }
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            children: paypalComponent
                        })
                    })
                ]
            })
        ]
    }));
};
/* harmony default export */ var PaymentForm_PaymentAccordion = (PaymentAccordion);

// EXTERNAL MODULE: ./node_modules/frames-react/dist/esm/index.js
var esm = __webpack_require__(71621);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Button/Button.js
var Button_Button = __webpack_require__(282);
;// CONCATENATED MODULE: ./components/PaymentForm/PaymentFormCheckout.tsx


















function PaymentFormCheckout_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function PaymentFormCheckout_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                PaymentFormCheckout_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                PaymentFormCheckout_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function PaymentFormCheckout_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var PaymentFormCheckout_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return {
        formContainer: {
            backgroundColor: '#fff'
        },
        inputField: {
            marginBottom: theme.spacing(2),
            height: 38,
            color: '#000'
        },
        cardDetails: {
            display: 'flex',
            gap: theme.spacing(2),
            marginBottom: theme.spacing(2)
        },
        payButtonContainer: {
            marginBottom: theme.spacing(6)
        },
        payButton: {
            width: '100%'
        },
        loaderContainer: {
            height: 300,
            width: '100%',
            alignContent: 'center',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
        }
    };
});
var framesStyles = {
    base: {
        color: '#000'
    },
    invalid: {
        color: '#eb1c26'
    },
    placeholder: {
        base: {
            fontFamily: 'sans-serif',
            color: '#555'
        }
    }
};
var PaymentFormCheckout_mapStateToProps = function(state) {
    return {
        cart: state.cart,
        payment: state.payment
    };
};
var PaymentFormCheckout_mapDispatchToProps = {
    postDadPayment: payment_postDadPayment,
    createCheckoutPayment: checkout/* createCheckoutPayment */.dG
};
function PaymentFormCheckout(param1) {
    var publicKey = param1.publicKey, t = param1.t, text = param1.text, settings = param1.settings, cart = param1.cart, postDadPayment1 = param1.postDadPayment, createCheckoutPayment1 = param1.createCheckoutPayment, coupon = param1.coupon, swikId = param1.swikId, disabled = param1.disabled;
    var classes = PaymentFormCheckout_useStyles();
    var commonClasses = (0,CardForm_style/* default */.Z)();
    var ref7 = (0,react.useState)(false), framesReady = ref7[0], setFramesReady = ref7[1];
    var ref1 = (0,react.useState)(false), cgu = ref1[0], setCgu = ref1[1];
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var ref2 = (0,useMatomo/* default */.Z)(), trackEvent = ref2.trackEvent, pushInstruction = ref2.pushInstruction;
    var router = (0,next_router.useRouter)();
    var ref3 = (0,react.useState)(null), error1 = ref3[0], setError = ref3[1];
    var ref4 = (0,react.useState)(false), paymentProcessing = ref4[0], setPaymentProcessing = ref4[1];
    var ref5 = (0,react.useState)(true), paymentFailed = ref5[0], setPaymentFailed = ref5[1];
    (0,react.useEffect)(function() {
        var ref, ref6;
        if (router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.insufficient_funds) {
            setError(t('texts:funnel:payment:errors:insufficient_funds'));
        } else if (router === null || router === void 0 ? void 0 : (ref6 = router.query) === null || ref6 === void 0 ? void 0 : ref6.error_3D) {
            setError(t('texts:funnel:payment:error'));
        }
    }, [
        router === null || router === void 0 ? void 0 : router.query
    ]);
    var changeCgu = function() {
        setCgu(!cgu);
    };
    var onFramesReady = function() {
        setFramesReady(true);
    };
    var handleFormSubmit = function(e) {
        e.preventDefault();
        esm/* Frames.submitCard */.IX.submitCard();
    };
    var cartToken1 = (0,react.useMemo)(function() {
        var ref;
        return cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.tokenValue;
    }, [
        cart
    ]);
    var handlePayment = function(cartToken) {
        return (function() {
            var _ref = PaymentFormCheckout_asyncToGenerator(runtime_default().mark(function _callee(e) {
                var email, linkLocal, data, payment, ref39, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, gaParams, cleanGAParams, ref30, ref31, ref32, ref33, ref34, ref35, error, ref36, productName;
                return runtime_default().wrap(function _callee$(_ctx) {
                    while(1)switch(_ctx.prev = _ctx.next){
                        case 0:
                            _ctx.next = 2;
                            return createCheckoutPayment1(cart.item.tokenValue);
                        case 2:
                            email = localStorage.getItem('email');
                            linkLocal = router.locale ? "/".concat(router.locale) : '';
                            data = {
                                email: email,
                                token: e.token,
                                frontSuccessPaymentUrl: "".concat(window.location.origin).concat(linkLocal, "/confirmation"),
                                frontFailPaymentUrl: "".concat(window.location.origin).concat(linkLocal, "/payment?error_3D=true"),
                                swik_id: swikId
                            };
                            _ctx.next = 7;
                            return postDadPayment1(data, cartToken);
                        case 7:
                            payment = _ctx.sent;
                            if (!((payment === null || payment === void 0 ? void 0 : payment.paymentResult.status) === 'Pending')) {
                                _ctx.next = 12;
                                break;
                            }
                            {
                                ;
                                // Because of 3d secure we open a new window, causing an unstable redux state.
                                // We set a local storage item in order to keep track of payment in confirmation page
                                localStorage.setItem('Payment type', '3dSecure');
                                window.open((ref39 = payment.paymentResult) === null || ref39 === void 0 ? void 0 : (ref8 = ref39._links) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.redirect) === null || ref9 === void 0 ? void 0 : ref9.href, '_self').focus();
                            }
                            _ctx.next = 62;
                            break;
                        case 12:
                            if (!(payment.paymentResult === 'Order completed')) {
                                _ctx.next = 27;
                                break;
                            }
                            ;
                            setPaymentProcessing(false);
                            setPaymentFailed(false);
                            _ctx.next = 18;
                            return pushInstruction('trackEcommerceOrder', cart === null || cart === void 0 ? void 0 : (ref10 = cart.item) === null || ref10 === void 0 ? void 0 : ref10.tokenValue, (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref11 = cart.item) === null || ref11 === void 0 ? void 0 : (ref12 = ref11.totals) === null || ref12 === void 0 ? void 0 : ref12.total), (0,utils/* numberToPrice */.e8)((cart === null || cart === void 0 ? void 0 : (ref13 = cart.item) === null || ref13 === void 0 ? void 0 : (ref14 = ref13.totals) === null || ref14 === void 0 ? void 0 : ref14.total) - (cart === null || cart === void 0 ? void 0 : (ref15 = cart.item) === null || ref15 === void 0 ? void 0 : (ref16 = ref15.totals) === null || ref16 === void 0 ? void 0 : ref16.shipping)), (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref17 = cart.item) === null || ref17 === void 0 ? void 0 : (ref18 = ref17.totals) === null || ref18 === void 0 ? void 0 : ref18.taxes), (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref19 = cart.item) === null || ref19 === void 0 ? void 0 : (ref20 = ref19.totals) === null || ref20 === void 0 ? void 0 : ref20.shipping), (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref21 = cart.item) === null || ref21 === void 0 ? void 0 : (ref22 = ref21.totals) === null || ref22 === void 0 ? void 0 : ref22.promotion) // discount (Optional) – Integer/Float/Boolean – Discount offered? Default to false. Otherwise, you should include a numeric value.
                            );
                        case 18:
                            gaParams = {
                                transaction_id: cart === null || cart === void 0 ? void 0 : (ref23 = cart.item) === null || ref23 === void 0 ? void 0 : ref23.tokenValue,
                                currency: cart.item.currency,
                                value: (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref24 = cart.item) === null || ref24 === void 0 ? void 0 : (ref25 = ref24.totals) === null || ref25 === void 0 ? void 0 : ref25.total),
                                tax: (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref26 = cart.item) === null || ref26 === void 0 ? void 0 : (ref27 = ref26.totals) === null || ref27 === void 0 ? void 0 : ref27.taxes),
                                shipping: (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref28 = cart.item) === null || ref28 === void 0 ? void 0 : (ref29 = ref28.totals) === null || ref29 === void 0 ? void 0 : ref29.shipping),
                                items: cart.item.items.map(function(param) {
                                    var product = param.product, quantity = param.quantity, total = param.total;
                                    var firstVariant = Object.values(product === null || product === void 0 ? void 0 : product.variants)[0];
                                    var _obj;
                                    return _obj = {}, PaymentFormCheckout_defineProperty(_obj, 'item_name', product.name), PaymentFormCheckout_defineProperty(_obj, 'item_id', gtag/* isChalhoub */.LP ? firstVariant.sku : product.code), PaymentFormCheckout_defineProperty(_obj, 'item_variant', gtag/* isChalhoub */.LP && firstVariant.code), PaymentFormCheckout_defineProperty(_obj, "price", (0,utils/* numberToPrice */.e8)(total)), PaymentFormCheckout_defineProperty(_obj, "quantity", quantity), _obj;
                                })
                            };
                            cleanGAParams = (0,gtag/* clearItemVariantFromGAParamsIfNotChalhoub */.o9)(gaParams);
                            gtag/* tracker */.ap(base/* GAEvent.PURCHASE */.gB.PURCHASE, cleanGAParams);
                            (0,gtag/* safeDataLayerPush */.Kx)((0,gtag/* getPaymentInfoGtmData */.yo)(cart, coupon, 'checkout'));
                            // Meta Pixel: Purchase event with amount and currency
                            if ( true && typeof window.fbq === 'function') {
                                ;
                                window.fbq('track', 'Purchase', {
                                    value: (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref30 = cart.item) === null || ref30 === void 0 ? void 0 : (ref31 = ref30.totals) === null || ref31 === void 0 ? void 0 : ref31.total),
                                    currency: cart === null || cart === void 0 ? void 0 : (ref32 = cart.item) === null || ref32 === void 0 ? void 0 : ref32.currency
                                });
                            }
                            _ctx.next = 25;
                            return router.push('/confirmation');
                        case 25:
                            _ctx.next = 62;
                            break;
                        case 27:
                            ;
                            error = payment === null || payment === void 0 ? void 0 : (ref33 = payment.err) === null || ref33 === void 0 ? void 0 : (ref34 = ref33.response) === null || ref34 === void 0 ? void 0 : (ref35 = ref34.data) === null || ref35 === void 0 ? void 0 : ref35.error;
                            if (!(error === 'some products are not available in stocks')) {
                                _ctx.next = 33;
                                break;
                            }
                            {
                                ;
                                productName = '';
                                cart === null || cart === void 0 ? void 0 : (ref36 = cart.item) === null || ref36 === void 0 ? void 0 : ref36.items.map(function(products) {
                                    productName = products.product.variants.find(function(variants) {
                                        var ref, ref37, ref38;
                                        return variants.code === (payment === null || payment === void 0 ? void 0 : (ref = payment.err) === null || ref === void 0 ? void 0 : (ref37 = ref.response) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.data) === null || ref38 === void 0 ? void 0 : ref38.unavailableProductVariants[0]);
                                    }).name;
                                });
                                setError("".concat(t('texts:funnel:payment:errors:stock'), " : ").concat(productName));
                            }
                            _ctx.next = 60;
                            break;
                        case 33:
                            if (!((error === null || error === void 0 ? void 0 : error.code) === 'card_declined')) {
                                _ctx.next = 49;
                                break;
                            }
                            _ctx.t0 = error === null || error === void 0 ? void 0 : error.decline_code;
                            _ctx.next = _ctx.t0 === 'insufficient_funds' ? 37 : _ctx.t0 === 'lost_card' ? 39 : _ctx.t0 === 'stolen_card' ? 41 : _ctx.t0 === 'Invalid email address' ? 43 : 45;
                            break;
                        case 37:
                            setError(t('texts:funnel:payment:errors:insufficient_funds'));
                            return _ctx.abrupt("break", 47);
                        case 39:
                            setError(t('texts:funnel:payment:errors:lost_card'));
                            return _ctx.abrupt("break", 47);
                        case 41:
                            setError(t('texts:funnel:payment:errors:stolen_card'));
                            return _ctx.abrupt("break", 47);
                        case 43:
                            setError(t('texts:funnel:payment:errors:email'));
                            return _ctx.abrupt("break", 47);
                        case 45:
                            setError(t('texts:funnel:payment:errors:default'));
                            return _ctx.abrupt("break", 47);
                        case 47:
                            _ctx.next = 60;
                            break;
                        case 49:
                            _ctx.t1 = error === null || error === void 0 ? void 0 : error.code;
                            _ctx.next = _ctx.t1 === 'expired_card' ? 52 : _ctx.t1 === 'incorrect_cvc' ? 54 : _ctx.t1 === 'processing_error' ? 56 : 58;
                            break;
                        case 52:
                            setError(t('texts:funnel:payment:errors:expired_card'));
                            return _ctx.abrupt("break", 60);
                        case 54:
                            setError(t('texts:funnel:payment:errors:incorrect_cvc'));
                            return _ctx.abrupt("break", 60);
                        case 56:
                            setError(t('texts:funnel:payment:errors:processing_error'));
                            return _ctx.abrupt("break", 60);
                        case 58:
                            setError(t('texts:funnel:payment:errors:default'));
                            return _ctx.abrupt("break", 60);
                        case 60:
                            setPaymentProcessing(false);
                            setPaymentFailed(true);
                        case 62:
                        case "end":
                            return _ctx.stop();
                    }
                }, _callee);
            }));
            return function(e) {
                return _ref.apply(this, arguments);
            };
        })();
    };
    var _obj1;
    return !cartToken1 ? /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        className: classes.loaderContainer,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
    }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Frames */.IX, {
        ready: onFramesReady,
        config: {
            publicKey: publicKey,
            schemeChoice: true,
            style: framesStyles,
            localization: {
                cardNumberPlaceholder: '1234 1234 1234 1234',
                expiryMonthPlaceholder: 'MM',
                expiryYearPlaceholder: 'AA',
                cvvPlaceholder: 'CVC'
            }
        },
        cardTokenized: handlePayment(cartToken1),
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("form", {
            className: commonClasses.form,
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.formContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: (0,clsx_m/* default */.Z)('label', commonClasses.label),
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: settings === null || settings === void 0 ? void 0 : settings.card_number,
                            defaultText: t('texts:general:card_number')
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* CardNumber */.ZQ, {
                        className: (0,clsx_m/* default */.Z)(classes.inputField, 'input', commonClasses.input),
                        placeholder: "1234 1234 1234 1234"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                        container: true,
                        justify: 'space-between',
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                xs: 5,
                                item: true,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,clsx_m/* default */.Z)('label', commonClasses.label),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: settings === null || settings === void 0 ? void 0 : settings.expiry_date,
                                            defaultText: t('texts:general:expiry_date')
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* ExpiryDate */.PS, {
                                        className: (0,clsx_m/* default */.Z)(classes.inputField, 'input', commonClasses.input)
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                xs: 5,
                                item: true,
                                className: "cb-infos",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                        className: (0,clsx_m/* default */.Z)('label', commonClasses.label),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                            asText: true,
                                            data: settings === null || settings === void 0 ? void 0 : settings.cvc_code,
                                            defaultText: t('texts:general:cvc_code')
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Cvv */.K, {
                                        className: (0,clsx_m/* default */.Z)(classes.inputField, 'input', commonClasses.input)
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                        control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                            checked: cgu,
                            onChange: changeCgu,
                            name: "checkedA",
                            "data-testid": 'cgu_check'
                        }),
                        label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: 'body2',
                            component: 'span',
                            className: commonClasses.cgu,
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                data: text === null || text === void 0 ? void 0 : text.cgu,
                                defaultText: t('texts:funnel:payment:cgu')
                            })
                        })
                    }),
                    paymentFailed && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        color: 'error',
                        variant: 'caption',
                        align: 'center',
                        component: "div",
                        children: error1
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                        className: classes.payButtonContainer,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                            disabled: !cgu || !esm/* Frames.isCardValid */.IX.isCardValid() || !framesReady || disabled,
                            className: (0,clsx_m/* default */.Z)(classes.payButton, commonClasses.submit, (_obj1 = {}, PaymentFormCheckout_defineProperty(_obj1, commonClasses.inProgress, paymentProcessing), PaymentFormCheckout_defineProperty(_obj1, 'payment-form__submit-progress', paymentProcessing), _obj1), 'payment-form__submit'),
                            variant: "contained",
                            "data-testid": "paymentSubmit",
                            color: "primary",
                            onClick: handleFormSubmit,
                            type: "submit",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                className: commonClasses.show,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                    asText: true,
                                    data: text === null || text === void 0 ? void 0 : text.pay,
                                    defaultText: t('texts:funnel:pay')
                                })
                            })
                        })
                    })
                ]
            })
        })
    });
}
/* harmony default export */ var PaymentForm_PaymentFormCheckout = ((0,es/* connect */.$j)(PaymentFormCheckout_mapStateToProps, PaymentFormCheckout_mapDispatchToProps)(PaymentFormCheckout));

// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/CircularProgress/CircularProgress.js
var CircularProgress = __webpack_require__(95477);
// EXTERNAL MODULE: ./node_modules/@mui/material/Alert/Alert.js + 6 modules
var Alert = __webpack_require__(21737);
// EXTERNAL MODULE: ./redux/actions/swikly.tsx
var swikly = __webpack_require__(64918);
// EXTERNAL MODULE: ./redux/services/swikly.tsx
var services_swikly = __webpack_require__(71371);
// EXTERNAL MODULE: ./components/Shop/Price.tsx
var Price = __webpack_require__(31907);
;// CONCATENATED MODULE: ./components/PaymentForm/SwiklyCaution.tsx















function SwiklyCaution_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function SwiklyCaution_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                SwiklyCaution_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                SwiklyCaution_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
var SwiklyCaution_useStyles = (0,makeStyles/* default */.Z)(function(theme) {
    return (0,createStyles/* default */.Z)({
        root: {
            marginBottom: theme.spacing(3)
        },
        cautionInfo: {
            backgroundColor: theme.palette.grey[50],
            padding: theme.spacing(2),
            borderRadius: theme.shape.borderRadius,
            marginBottom: theme.spacing(2)
        },
        cautionAmount: {
            fontWeight: 'bold',
            color: theme.palette.primary.main
        },
        cautionButton: {
            width: '100%',
            marginBottom: theme.spacing(2)
        },
        loadingContainer: {
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            padding: theme.spacing(2)
        },
        statusContainer: {
            marginTop: theme.spacing(2)
        },
        successStatus: {
            color: theme.palette.success.main
        },
        errorStatus: {
            color: theme.palette.error.main
        }
    });
});
/**
 * SwiklyCaution component for handling deposit payments
 *
 * This component manages the creation and status checking of Swikly deposits.
 * It handles the complete flow from creating a deposit to checking its status
 * after the user returns from the Swikly payment page.
 *
 * Features:
 * - Calculates deposit amount based on cart items and deposit percentage
 * - Creates Swikly deposit requests
 * - Redirects to Swikly payment page
 * - Checks deposit status on return from Swikly
 * - Handles various deposit statuses (pending, accepted, error)
 * - Supports multiple languages
 */ var SwiklyCaution = function(param) {
    var cart = param.cart, parameters = param.parameters, createSwiklyCaution1 = param.createSwiklyCaution, getSwiklyCautionStatus1 = param.getSwiklyCautionStatus, onCautionComplete = param.onCautionComplete, _days = param.days, days = _days === void 0 ? 30 : _days, depositExplanation = param.depositExplanation, cautionInfo = param.cautionInfo;
    var ref7;
    var classes = SwiklyCaution_useStyles();
    var ref1 = (0,useTranslation/* useTranslation */.$)(), t = ref1.t, i18n = ref1.i18n;
    var router = (0,next_router.useRouter)();
    var ref2 = (0,react.useState)(null), cautionStatus = ref2[0], setCautionStatus = ref2[1];
    var ref3 = (0,react.useState)(null), cautionId = ref3[0], setCautionId = ref3[1];
    var ref4 = (0,react.useState)(false), loading = ref4[0], setLoading = ref4[1];
    var ref5 = (0,react.useState)(null), error = ref5[0], setError = ref5[1];
    var ref6 = (0,react.useState)(false), isCheckingStatus = ref6[0], setIsCheckingStatus = ref6[1];
    var isMountedRef = (0,react.useRef)(true);
    var processedUrlRef = (0,react.useRef)(null);
    // Get deposit percentage from environment variable (as decimal)
    var depositPercentage = constants/* swiklyDepositPercentage */.Hv ? parseFloat(constants/* swiklyDepositPercentage */.Hv) : 0;
    // Calculate deposit amount
    var depositAmount = (0,react.useMemo)(function() {
        var ref10;
        return (ref10 = cart.item) === null || ref10 === void 0 ? void 0 : ref10.items.reduce(function(acc, item) {
            var ref, ref8;
            var ref9;
            var originalPrice = (ref9 = (ref = item.product.variants[0]) === null || ref === void 0 ? void 0 : (ref8 = ref.originalPrice) === null || ref8 === void 0 ? void 0 : ref8.current) !== null && ref9 !== void 0 ? ref9 : 0;
            if (originalPrice) {
                return acc + originalPrice * item.quantity * depositPercentage;
            }
            return acc;
        }, 0);
    }, [
        (ref7 = cart.item) === null || ref7 === void 0 ? void 0 : ref7.items
    ]);
    // Check if caution is enabled - use environment variable instead of parameters
    var isCautionEnabled = depositPercentage > 0;
    (0,react.useEffect)(function() {
        // Check if there's a return from Swikly with status parameters
        var _query = router.query, status = _query.status, reference = _query.reference;
        var currentUrl = router.asPath;
        // Only proceed if we have a successful status and haven't already set a caution ID
        // and we haven't already processed this URL
        if (status === 'OK' && !cautionId && !isCheckingStatus && !loading && processedUrlRef.current !== currentUrl) {
            processedUrlRef.current = currentUrl;
            if (reference) {
                // Use the reference parameter to check status
                setCautionId(reference);
                checkCautionStatus(reference);
            }
        }
        // Cleanup function to prevent state updates on unmounted component
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    // Reset loading state when component unmounts or router changes
    (0,react.useEffect)(function() {
        return function() {
            if (isMountedRef.current) {
                setLoading(false);
                setIsCheckingStatus(false);
            }
        };
    }, []);
    var checkCautionStatus = function() {
        var _ref = SwiklyCaution_asyncToGenerator(runtime_default().mark(function _callee(id) {
            var ref, response, request, status;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(isCheckingStatus || loading)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        _ctx.prev = 2;
                        ;
                        setIsCheckingStatus(true);
                        setLoading(true);
                        _ctx.next = 8;
                        return getSwiklyCautionStatus1(id);
                    case 8:
                        response = _ctx.sent;
                        if (isMountedRef.current) {
                            _ctx.next = 11;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 11:
                        request = response.request;
                        status = (ref = request.deposit) === null || ref === void 0 ? void 0 : ref.status;
                        if (!(request.customId !== cart.item.tokenValue)) {
                            _ctx.next = 18;
                            break;
                        }
                        setCautionStatus('error');
                        setError(t('texts:funnel:payment:caution_token_mismatch'));
                        // Clear router query to prevent reprocessing the same invalid caution
                        router.replace(router.pathname, undefined, {
                            shallow: true
                        });
                        return _ctx.abrupt("return");
                    case 18:
                        // Check deposit status based on Swikly API spec
                        if ([
                            'Accepted',
                            'Released'
                        ].includes(status)) {
                            setCautionStatus('accepted');
                            onCautionComplete(id);
                        } else if ([
                            'Expired',
                            'Canceled',
                            'Failed',
                            'ExpiredWithoutAcceptance'
                        ].includes(status)) {
                            setCautionStatus('error');
                            setError(t('texts:funnel:payment:caution_expired'));
                        } else if ([
                            'Pending',
                            'Initialized',
                            'Temporary'
                        ].includes(status)) {
                            setCautionStatus('pending');
                        } else {
                            setCautionStatus('pending');
                        }
                        setLoading(false);
                        setIsCheckingStatus(false);
                        _ctx.next = 26;
                        break;
                    case 23:
                        _ctx.prev = 23;
                        _ctx.t0 = _ctx["catch"](2);
                        // Check if component is still mounted before updating state
                        if (isMountedRef.current) {
                            setCautionStatus('error');
                            setError(t('texts:funnel:payment:caution_error'));
                            setLoading(false);
                            setIsCheckingStatus(false);
                        }
                    case 26:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    23
                ]
            ]);
        }));
        return function checkCautionStatus(id) {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCreateCaution = function() {
        var _ref = SwiklyCaution_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, cartItem, customerEmail, ref11, firstName, lastName, countryCode, city, street, postcode, phoneNumber, endDate, currentLang, getSwiklyLanguage, swiklyLang, cautionData, caution;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        if (!(!isCautionEnabled || depositAmount <= 0)) {
                            _ctx.next = 2;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 2:
                        _ctx.prev = 2;
                        ;
                        setLoading(true);
                        setError(null);
                        cartItem = cart.item;
                        customerEmail = localStorage.getItem('email');
                        ref11 = (cartItem === null || cartItem === void 0 ? void 0 : cartItem.billingAddress) || {}, firstName = ref11.firstName, lastName = ref11.lastName, countryCode = ref11.countryCode, city = ref11.city, street = ref11.street, postcode = ref11.postcode, phoneNumber = ref11.phoneNumber;
                        endDate = dayjs_min_default()(cartItem.endLeasingDate, 'DD/MM/YYYY').add(days, 'day');
                        currentLang = ((ref = i18n.language) === null || ref === void 0 ? void 0 : ref.toLowerCase()) || 'en';
                        getSwiklyLanguage = function(lang) {
                            switch(lang){
                                case 'fr':
                                    return services_swikly/* SwiklyLanguage.FR */.OO.FR;
                                case 'en':
                                    return services_swikly/* SwiklyLanguage.EN */.OO.EN;
                                case 'nl':
                                    return services_swikly/* SwiklyLanguage.NL */.OO.NL;
                                case 'de':
                                    return services_swikly/* SwiklyLanguage.DE */.OO.DE;
                                case 'es':
                                    return services_swikly/* SwiklyLanguage.ES */.OO.ES;
                                case 'it':
                                    return services_swikly/* SwiklyLanguage.IT */.OO.IT;
                                default:
                                    return services_swikly/* SwiklyLanguage.EN */.OO.EN;
                            }
                        };
                        swiklyLang = getSwiklyLanguage(currentLang);
                        cautionData = {
                            description: t('texts:funnel:payment:swikly_deposit_description'),
                            language: swiklyLang,
                            customId: cart.item.tokenValue,
                            customIdMustBeUnique: true,
                            firstName: firstName || undefined,
                            lastName: lastName || undefined,
                            email: customerEmail,
                            phoneNumber: phoneNumber,
                            redirectUrl: window.location.href,
                            callbacks: {
                            },
                            deposit: {
                                startDate: dayjs_min_default()().format('YYYY-MM-DD'),
                                endDate: endDate.format('YYYY-MM-DD'),
                                amount: depositAmount
                            },
                            address: {
                                country: countryCode,
                                city: city,
                                street: street,
                                postcode: postcode
                            }
                        };
                        _ctx.next = 16;
                        return createSwiklyCaution1(cautionData);
                    case 16:
                        caution = _ctx.sent;
                        setCautionId(caution.request.id);
                        // Redirect to Swikly payment page
                        if (caution.request.link) {
                            window.location.href = caution.request.link;
                        }
                        _ctx.next = 24;
                        break;
                    case 21:
                        _ctx.prev = 21;
                        _ctx.t0 = _ctx["catch"](2);
                        setError(t('texts:funnel:payment:caution_creation_error'));
                    case 24:
                        _ctx.prev = 24;
                        setLoading(false);
                        return _ctx.finish(24);
                    case 27:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    2,
                    21,
                    24,
                    27
                ]
            ]);
        }));
        return function handleCreateCaution() {
            return _ref.apply(this, arguments);
        };
    }();
    if (!isCautionEnabled || depositAmount <= 0) {
        return null;
    }
    if (cautionStatus === 'accepted') {
        return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
            className: classes.root,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                severity: "success",
                className: classes.statusContainer,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                    asText: true,
                    data: parameters === null || parameters === void 0 ? void 0 : parameters.caution_paid_message,
                    defaultText: t('texts:funnel:payment:caution_paid')
                })
            })
        }));
    }
    return(/*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        className: classes.root,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.cautionInfo,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        gutterBottom: true,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: cautionInfo,
                            defaultText: t('texts:funnel:payment:caution_info')
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                        variant: "h6",
                        className: classes.cautionAmount,
                        children: [
                            t('texts:basket:deposit'),
                            ":",
                            ' ',
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Price/* default */.Z, {
                                amount: depositAmount,
                                showDayOrMonth: false
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "caption",
                        color: "textSecondary",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                            asText: true,
                            data: depositExplanation,
                            defaultText: t('texts:basket:deposit_explanation')
                        })
                    })
                ]
            }),
            error && /*#__PURE__*/ (0,jsx_runtime.jsx)(Alert/* default */.Z, {
                severity: "error",
                className: classes.statusContainer,
                children: error
            }),
            loading ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                className: classes.loadingContainer,
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(CircularProgress/* default */.Z, {
                        size: 24
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        variant: "body2",
                        style: {
                            marginLeft: 8
                        },
                        children: t('texts:funnel:payment:processing_caution')
                    })
                ]
            }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button_Button/* default */.Z, {
                variant: "outlined",
                color: "primary",
                className: (0,clsx_m/* default */.Z)(classes.cautionButton, 'swikly-caution-button'),
                onClick: handleCreateCaution,
                disabled: cautionStatus === 'error',
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                    asText: true,
                    data: parameters === null || parameters === void 0 ? void 0 : parameters.caution_button,
                    defaultText: t('texts:funnel:payment:pay_caution')
                })
            })
        ]
    }));
};
var SwiklyCaution_mapDispatchToProps = {
    createSwiklyCaution: swikly/* createSwiklyCaution */.Xl,
    getSwiklyCautionStatus: swikly/* getSwiklyCautionStatus */.ZU
};
/* harmony default export */ var PaymentForm_SwiklyCaution = ((0,es/* connect */.$j)(null, SwiklyCaution_mapDispatchToProps)(SwiklyCaution));

// EXTERNAL MODULE: ./redux/actions/cart.ts
var cart = __webpack_require__(14596);
;// CONCATENATED MODULE: ./pages/payment.tsx
/* provided dependency */ var payment_process = __webpack_require__(34155);











































function payment_asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function payment_asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                payment_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                payment_asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function payment_defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
var payment_mapStateToProps = function(state) {
    return {
        cart: state.cart,
        parameters: state.parameters,
        promotions: state.promotions,
        checkout: state.checkout,
        user: state.user.user,
        isLoggedIn: state.user.isLoggedIn
    };
};
var payment_mapDispatchToProps = {
    createCheckoutPayment: checkout/* createCheckoutPayment */.dG,
    postSubPayment: payment_postSubPayment,
    postDadPayment: payment_postDadPayment,
    postBypassDadPayment: payment_postBypassDadPayment,
    postWireTransferDadPayment: payment_postWireTransferDadPayment,
    setFunnelStep: cart/* setFunnelStep */.iU
};
var Payment = function(param1) {
    var doc = param1.doc, main = param1.main, accountRes = param1.accountRes, faqRes = param1.faqRes, basket = param1.basket, funnel = param1.funnel, inStoreText = param1.inStoreText, promotions = param1.promotions, createCheckoutPayment1 = param1.createCheckoutPayment, takeback = param1.takeback, postSubPayment1 = param1.postSubPayment, postDadPayment1 = param1.postDadPayment, postBypassDadPayment1 = param1.postBypassDadPayment, postWireTransferDadPayment1 = param1.postWireTransferDadPayment, cart = param1.cart, parameters = param1.parameters, checkout = param1.checkout, banner = param1.banner, setFunnelStep1 = param1.setFunnelStep, user = param1.user, isLoggedIn = param1.isLoggedIn;
    var ref75, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12, ref13, ref14, ref15, ref16, ref17, ref18, ref19, ref20, ref21, ref22, ref23, ref24, ref25, ref26, ref27, ref28, ref29, ref30, ref31, ref32, ref33, ref34, ref35, ref36, ref37, ref38, ref39, ref40, ref41, ref42, ref43, ref44, ref45, ref46, ref47, ref48, ref49, ref50, ref51, ref52, ref53, ref54, ref55, ref56, ref57;
    var ref58 = (0,useCart/* useCart */.j)(), putCoupon = ref58.putCoupon, getCart = ref58.getCart, deleteCoupon = ref58.deleteCoupon;
    var classes = (0,Funnel_style/* default */.Z)();
    var router = (0,next_router.useRouter)();
    var t = (0,useTranslation/* useTranslation */.$)().t;
    var dispatch = (0,es/* useDispatch */.I0)();
    var informationSkipped = (0,useInformationSkipped/* useInformationSkipped */.v)();
    var ref59 = (0,useMatomo/* default */.Z)(), trackPageView = ref59.trackPageView, trackEvent = ref59.trackEvent, pushInstruction = ref59.pushInstruction;
    var ref60 = (0,react.useState)(''), code = ref60[0], setCode = ref60[1];
    var ref61 = (0,react.useState)(''), codeOperator = ref61[0], setCodeOperator = ref61[1];
    var ref62 = (0,react.useState)(false), minimumCartItemsError = ref62[0], setMinimumCartItemsError = ref62[1];
    var ref63 = (0,react.useState)(false), couponValid = ref63[0], setCouponValid = ref63[1];
    var ref64 = (0,react.useState)(false), couponError = ref64[0], setCouponError = ref64[1];
    var ref65 = (0,react.useState)(false), couponRemoved = ref65[0], setCouponRemoved = ref65[1];
    var ref66 = (0,react.useState)(false), errorCodeOperator = ref66[0], setErrorCodeOperator = ref66[1];
    var ref67 = (0,react.useState)(false), errorMessage = ref67[0], setErrorMessage = ref67[1];
    var hasStockError = (0,useCartHasStockError/* useCartHasStockError */.V)();
    var stripePromise = (0,useStripePromise/* useStripePromise */.x)(parameters === null || parameters === void 0 ? void 0 : (ref75 = parameters.items) === null || ref75 === void 0 ? void 0 : ref75.in_store);
    var ref68 = (0,react.useState)(false), isLoader = ref68[0], setIsLoader = ref68[1];
    var ref69 = (0,react.useState)(false), depositCompleted = ref69[0], setDepositCompleted = ref69[1];
    var ref70 = (0,react.useState)(false), byPassCgu = ref70[0], setByPassCgu = ref70[1];
    var userBypassPayment = (user === null || user === void 0 ? void 0 : user.bypassPayment) === true && isLoggedIn;
    var ref71 = (0,react.useState)(constants/* byPassPayment */.wU), byPassPayment = ref71[0], setByPassPayment = ref71[1];
    (0,react.useEffect)(function() {
        dispatch((0,prismic/* SAVE_PRISMIC_DOCUMENTS */.w)({
            general: main === null || main === void 0 ? void 0 : main.data,
            funnel: funnel === null || funnel === void 0 ? void 0 : funnel.data,
            account: accountRes === null || accountRes === void 0 ? void 0 : accountRes.data,
            instore: inStoreText === null || inStoreText === void 0 ? void 0 : inStoreText.data
        }));
    }, [
        funnel,
        main,
        inStoreText
    ]);
    // Extract swik_id from router query
    var reference = router.query.reference;
    var changeByPassCgu = function() {
        setByPassCgu(!byPassCgu);
    };
    (0,react.useEffect)(function() {
        var ref, ref72;
        trackPageView({
            documentTitle: 'Payment'
        });
        // Fetch/refresh cart data when component mounts to ensure latest data
        var cartToken = localStorage.getItem('CartToken');
        if (cartToken && (cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.tokenValue) && cartToken !== (cart === null || cart === void 0 ? void 0 : (ref72 = cart.item) === null || ref72 === void 0 ? void 0 : ref72.tokenValue)) {
            var ref73, ref74;
            localStorage.setItem('CartToken', cart === null || cart === void 0 ? void 0 : (ref73 = cart.item) === null || ref73 === void 0 ? void 0 : ref73.tokenValue);
            getCart(cart === null || cart === void 0 ? void 0 : (ref74 = cart.item) === null || ref74 === void 0 ? void 0 : ref74.tokenValue);
        }
        setFunnelStep1((0,utils_funnel/* getFunnelStepIndex */.Lf)('payment'));
    }, []);
    (0,react.useEffect)(function() {
        if (false) {}
    }, [
        promotions
    ]);
    (0,react.useEffect)(function() {
        if ((user === null || user === void 0 ? void 0 : user.bypassPayment) || constants/* byPassPayment */.wU) {
            setByPassPayment(true);
        }
    }, [
        user
    ]);
    (0,react.useEffect)(function() {
        {
            var // Redirect to shop page if no products in cart
            ref, ref76;
            (cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : (ref76 = ref.items) === null || ref76 === void 0 ? void 0 : ref76.length) === 0 && (cart === null || cart === void 0 ? void 0 : cart.status) === 'cart live' && (checkout === null || checkout === void 0 ? void 0 : checkout.pdfResponse) !== 'Order completed' && router.push('/shop');
            (0,utils/* checkTryOutError */.HC)(cart) && router.push('/shop');
        }
    }, [
        cart === null || cart === void 0 ? void 0 : (ref1 = cart.item) === null || ref1 === void 0 ? void 0 : ref1.items,
        cart === null || cart === void 0 ? void 0 : cart.status,
        checkout
    ]);
    (0,react.useEffect)(function() {
        var ref;
        if ((ref = cart.item) === null || ref === void 0 ? void 0 : ref.couponCode) {
            var ref77;
            setCouponValid(true);
            setCode((ref77 = cart.item) === null || ref77 === void 0 ? void 0 : ref77.couponCode);
        }
    }, [
        (ref2 = cart.item) === null || ref2 === void 0 ? void 0 : ref2.couponCode
    ]);
    var applyCoupon = function() {
        var _ref = payment_asyncToGenerator(runtime_default().mark(function _callee() {
            var isCoupon, ref;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        setCouponValid(false);
                        setCouponError(false);
                        _ctx.next = 4;
                        return putCoupon(code);
                    case 4:
                        isCoupon = _ctx.sent;
                        if (isCoupon.type === 'PUT_CART_COUPON_SUCCESS') {
                            setCouponValid(true);
                        } else {
                            ;
                            if ((cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.couponCode) !== code) {
                                setCouponError(true);
                            }
                        }
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function applyCoupon() {
            return _ref.apply(this, arguments);
        };
    }();
    var clearCoupon = function() {
        var _ref = payment_asyncToGenerator(runtime_default().mark(function _callee() {
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return deleteCoupon();
                    case 2:
                        setCouponValid(false);
                        setCouponError(false);
                        setCouponRemoved(true);
                        setCode('');
                    case 6:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function clearCoupon() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleCodeOperatorValue = function(value) {
        setCodeOperator(value);
    };
    var handleByPassOrder = function() {
        var _ref = payment_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, ref78, ref79, data, payment, ref80, ref81, ref82, ref83, ref84, ref85, ref86, ref87, ref88, ref89, ref90, ref91, ref92, ref93, ref94, ref95, ref96, ref97, ref98, ref99, ref100, gaParams, GTMData, cleanGAParams, ref101, ref102, ref103, ref104, ref105;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!hasStockError) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        setIsLoader(true);
                        setErrorMessage(false);
                        setErrorCodeOperator(false);
                        _ctx.next = 8;
                        return createCheckoutPayment1(cart.item.tokenValue);
                    case 8:
                        data = {};
                        if (constants/* byPassPayment */.wU && (parameters === null || parameters === void 0 ? void 0 : (ref = parameters.items) === null || ref === void 0 ? void 0 : ref.canByPassPayment)) {
                            data['email'] = localStorage.getItem('email');
                            data['byPassPassword'] = constants/* byPassPassword */.X9 ? constants/* byPassPassword */.X9 : codeOperator;
                            data['byPassType'] = constants/* byPassPassword */.X9 ? constants/* BY_PASS_TYPE.CUSTOMER */.sP.CUSTOMER : constants/* BY_PASS_TYPE.OPERATOR */.sP.OPERATOR;
                        } else {
                            if (byPassPayment) {
                                data['byPassType'] = constants/* BY_PASS_TYPE.CUSTOMER */.sP.CUSTOMER;
                            }
                            data['email'] = localStorage.getItem('email');
                        }
                        // Add swik_id if available from router query
                        if (reference) {
                            data['swik_id'] = reference;
                        }
                        // add parcelShop id if exist
                        if (((ref79 = cart === null || cart === void 0 ? void 0 : (ref78 = cart.item) === null || ref78 === void 0 ? void 0 : ref78.shipments[0].method) === null || ref79 === void 0 ? void 0 : ref79.type) !== 'HOME_DELIVERY' && typeof localStorage.getItem('rmsParcelShopId') !== 'undefined' && localStorage.getItem('rmsParcelShopId') !== null) {
                            data['parcelShopId'] = localStorage.getItem('rmsParcelShopId');
                        }
                        payment = null;
                        if (constants/* isSubscription */.Nn) {
                            _ctx.next = 25;
                            break;
                        }
                        if (!userBypassPayment) {
                            _ctx.next = 20;
                            break;
                        }
                        _ctx.next = 17;
                        return postBypassDadPayment1(data, cart.item.tokenValue);
                    case 17:
                        payment = _ctx.sent;
                        _ctx.next = 23;
                        break;
                    case 20:
                        _ctx.next = 22;
                        return postDadPayment1(data, cart.item.tokenValue);
                    case 22:
                        payment = _ctx.sent;
                    case 23:
                        _ctx.next = 28;
                        break;
                    case 25:
                        _ctx.next = 27;
                        return postSubPayment1(data, cart.item.tokenValue);
                    case 27:
                        payment = _ctx.sent;
                    case 28:
                        if (!((payment === null || payment === void 0 ? void 0 : payment.paymentResult) === 'Order completed')) {
                            _ctx.next = 41;
                            break;
                        }
                        ;
                        _ctx.next = 32;
                        return pushInstruction('trackEcommerceOrder', cart === null || cart === void 0 ? void 0 : (ref80 = cart.item) === null || ref80 === void 0 ? void 0 : ref80.tokenValue, (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref81 = cart.item) === null || ref81 === void 0 ? void 0 : (ref82 = ref81.totals) === null || ref82 === void 0 ? void 0 : ref82.total), (0,utils/* numberToPrice */.e8)((cart === null || cart === void 0 ? void 0 : (ref83 = cart.item) === null || ref83 === void 0 ? void 0 : (ref84 = ref83.totals) === null || ref84 === void 0 ? void 0 : ref84.total) - (cart === null || cart === void 0 ? void 0 : (ref85 = cart.item) === null || ref85 === void 0 ? void 0 : (ref86 = ref85.totals) === null || ref86 === void 0 ? void 0 : ref86.shipping)), (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref87 = cart.item) === null || ref87 === void 0 ? void 0 : (ref88 = ref87.totals) === null || ref88 === void 0 ? void 0 : ref88.taxes), (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref89 = cart.item) === null || ref89 === void 0 ? void 0 : (ref90 = ref89.totals) === null || ref90 === void 0 ? void 0 : ref90.shipping), (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref91 = cart.item) === null || ref91 === void 0 ? void 0 : (ref92 = ref91.totals) === null || ref92 === void 0 ? void 0 : ref92.promotion));
                    case 32:
                        gaParams = {
                            transaction_id: cart === null || cart === void 0 ? void 0 : (ref93 = cart.item) === null || ref93 === void 0 ? void 0 : ref93.tokenValue,
                            currency: cart === null || cart === void 0 ? void 0 : (ref94 = cart.item) === null || ref94 === void 0 ? void 0 : ref94.currency,
                            value: (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref95 = cart.item) === null || ref95 === void 0 ? void 0 : (ref96 = ref95.totals) === null || ref96 === void 0 ? void 0 : ref96.total),
                            tax: (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref97 = cart.item) === null || ref97 === void 0 ? void 0 : (ref98 = ref97.totals) === null || ref98 === void 0 ? void 0 : ref98.taxes),
                            shipping: (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref99 = cart.item) === null || ref99 === void 0 ? void 0 : (ref100 = ref99.totals) === null || ref100 === void 0 ? void 0 : ref100.shipping),
                            items: cart.item.items.map(function(param) {
                                var product = param.product, quantity = param.quantity, total = param.total;
                                var firstVariant = Object.values(product === null || product === void 0 ? void 0 : product.variants)[0];
                                var _obj;
                                return _obj = {}, payment_defineProperty(_obj, 'item_name', product === null || product === void 0 ? void 0 : product.name), payment_defineProperty(_obj, 'item_id', gtag/* isChalhoub */.LP ? firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.sku : product === null || product === void 0 ? void 0 : product.code), payment_defineProperty(_obj, 'item_variant', gtag/* isChalhoub */.LP && (firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.code)), payment_defineProperty(_obj, "price", (0,utils/* numberToPrice */.e8)(total)), payment_defineProperty(_obj, "quantity", quantity), _obj;
                            })
                        };
                        GTMData = (0,gtag/* getPaymentInfoGtmData */.yo)(cart, couponValid ? code : '', 'bypass');
                        cleanGAParams = (0,gtag/* clearItemVariantFromGAParamsIfNotChalhoub */.o9)(gaParams);
                        gtag/* tracker */.ap(base/* GAEvent.PURCHASE */.gB.PURCHASE, cleanGAParams);
                        (0,gtag/* safeDataLayerPush */.Kx)(GTMData);
                        // Meta Pixel: Purchase event with amount and currency
                        if ( true && typeof window.fbq === 'function') {
                            ;
                            window.fbq('track', 'Purchase', {
                                value: (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref101 = cart.item) === null || ref101 === void 0 ? void 0 : (ref102 = ref101.totals) === null || ref102 === void 0 ? void 0 : ref102.total),
                                currency: cart === null || cart === void 0 ? void 0 : (ref103 = cart.item) === null || ref103 === void 0 ? void 0 : ref103.currency
                            });
                        }
                        _ctx.next = 40;
                        return router.push('/confirmation');
                    case 40:
                        setIsLoader(false);
                    case 41:
                        if (payment === null || payment === void 0 ? void 0 : payment.err) {
                            ;
                            setIsLoader(false);
                            if ((payment === null || payment === void 0 ? void 0 : (ref104 = payment.err) === null || ref104 === void 0 ? void 0 : ref104.response.data) === 'wrong byPassPassword') {
                                setErrorCodeOperator(true);
                            } else if ((payment === null || payment === void 0 ? void 0 : (ref105 = payment.err) === null || ref105 === void 0 ? void 0 : ref105.response.data) === constants/* minimumCartItemsNotReached */.Wf) {
                                setMinimumCartItemsError(true);
                            } else {
                                setErrorMessage(true);
                            }
                        }
                    case 42:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleByPassOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    var handleWireTransferOrder = function() {
        var _ref = payment_asyncToGenerator(runtime_default().mark(function _callee() {
            var ref, ref106, data, payment, ref107, ref108, ref109, ref110, ref111, ref112, ref113, ref114, ref115, ref116, ref117, ref118, ref119, ref120, ref121, ref122, ref123, ref124, ref125, ref126, ref127, gaParams, GTMData, cleanGAParams, ref128, ref129, ref130, ref131;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (!hasStockError) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return");
                    case 3:
                        setIsLoader(true);
                        setErrorMessage(false);
                        _ctx.next = 7;
                        return createCheckoutPayment1(cart.item.tokenValue);
                    case 7:
                        data = {
                            email: localStorage.getItem('email'),
                            byPassType: constants/* BY_PASS_TYPE.CUSTOMER */.sP.CUSTOMER
                        };
                        if (((ref106 = cart === null || cart === void 0 ? void 0 : (ref = cart.item) === null || ref === void 0 ? void 0 : ref.shipments[0].method) === null || ref106 === void 0 ? void 0 : ref106.type) !== 'HOME_DELIVERY' && typeof localStorage.getItem('rmsParcelShopId') !== 'undefined' && localStorage.getItem('rmsParcelShopId') !== null) {
                            data['parcelShopId'] = localStorage.getItem('rmsParcelShopId');
                        }
                        _ctx.next = 11;
                        return postWireTransferDadPayment1(data, cart.item.tokenValue);
                    case 11:
                        payment = _ctx.sent;
                        if (!((payment === null || payment === void 0 ? void 0 : payment.paymentResult) === 'Order completed')) {
                            _ctx.next = 25;
                            break;
                        }
                        ;
                        _ctx.next = 16;
                        return pushInstruction('trackEcommerceOrder', cart === null || cart === void 0 ? void 0 : (ref107 = cart.item) === null || ref107 === void 0 ? void 0 : ref107.tokenValue, (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref108 = cart.item) === null || ref108 === void 0 ? void 0 : (ref109 = ref108.totals) === null || ref109 === void 0 ? void 0 : ref109.total), (0,utils/* numberToPrice */.e8)((cart === null || cart === void 0 ? void 0 : (ref110 = cart.item) === null || ref110 === void 0 ? void 0 : (ref111 = ref110.totals) === null || ref111 === void 0 ? void 0 : ref111.total) - (cart === null || cart === void 0 ? void 0 : (ref112 = cart.item) === null || ref112 === void 0 ? void 0 : (ref113 = ref112.totals) === null || ref113 === void 0 ? void 0 : ref113.shipping)), (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref114 = cart.item) === null || ref114 === void 0 ? void 0 : (ref115 = ref114.totals) === null || ref115 === void 0 ? void 0 : ref115.taxes), (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref116 = cart.item) === null || ref116 === void 0 ? void 0 : (ref117 = ref116.totals) === null || ref117 === void 0 ? void 0 : ref117.shipping), (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref118 = cart.item) === null || ref118 === void 0 ? void 0 : (ref119 = ref118.totals) === null || ref119 === void 0 ? void 0 : ref119.promotion));
                    case 16:
                        gaParams = {
                            transaction_id: cart === null || cart === void 0 ? void 0 : (ref120 = cart.item) === null || ref120 === void 0 ? void 0 : ref120.tokenValue,
                            currency: cart === null || cart === void 0 ? void 0 : (ref121 = cart.item) === null || ref121 === void 0 ? void 0 : ref121.currency,
                            value: (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref122 = cart.item) === null || ref122 === void 0 ? void 0 : (ref123 = ref122.totals) === null || ref123 === void 0 ? void 0 : ref123.total),
                            tax: (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref124 = cart.item) === null || ref124 === void 0 ? void 0 : (ref125 = ref124.totals) === null || ref125 === void 0 ? void 0 : ref125.taxes),
                            shipping: (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref126 = cart.item) === null || ref126 === void 0 ? void 0 : (ref127 = ref126.totals) === null || ref127 === void 0 ? void 0 : ref127.shipping),
                            items: cart.item.items.map(function(param) {
                                var product = param.product, quantity = param.quantity, total = param.total;
                                var firstVariant = Object.values(product === null || product === void 0 ? void 0 : product.variants)[0];
                                var _obj;
                                return _obj = {}, payment_defineProperty(_obj, 'item_name', product === null || product === void 0 ? void 0 : product.name), payment_defineProperty(_obj, 'item_id', gtag/* isChalhoub */.LP ? firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.sku : product === null || product === void 0 ? void 0 : product.code), payment_defineProperty(_obj, 'item_variant', gtag/* isChalhoub */.LP && (firstVariant === null || firstVariant === void 0 ? void 0 : firstVariant.code)), payment_defineProperty(_obj, "price", (0,utils/* numberToPrice */.e8)(total)), payment_defineProperty(_obj, "quantity", quantity), _obj;
                            })
                        };
                        GTMData = (0,gtag/* getPaymentInfoGtmData */.yo)(cart, couponValid ? code : '', 'wire_transfer');
                        cleanGAParams = (0,gtag/* clearItemVariantFromGAParamsIfNotChalhoub */.o9)(gaParams);
                        gtag/* tracker */.ap(base/* GAEvent.PURCHASE */.gB.PURCHASE, cleanGAParams);
                        (0,gtag/* safeDataLayerPush */.Kx)(GTMData);
                        if ( true && typeof window.fbq === 'function') {
                            ;
                            window.fbq('track', 'Purchase', {
                                value: (0,utils/* numberToPrice */.e8)(cart === null || cart === void 0 ? void 0 : (ref128 = cart.item) === null || ref128 === void 0 ? void 0 : (ref129 = ref128.totals) === null || ref129 === void 0 ? void 0 : ref129.total),
                                currency: cart === null || cart === void 0 ? void 0 : (ref130 = cart.item) === null || ref130 === void 0 ? void 0 : ref130.currency
                            });
                        }
                        _ctx.next = 24;
                        return router.push('/confirmation');
                    case 24:
                        setIsLoader(false);
                    case 25:
                        if (payment === null || payment === void 0 ? void 0 : payment.err) {
                            ;
                            setIsLoader(false);
                            if ((payment === null || payment === void 0 ? void 0 : (ref131 = payment.err) === null || ref131 === void 0 ? void 0 : ref131.response.data) === constants/* minimumCartItemsNotReached */.Wf) {
                                setMinimumCartItemsError(true);
                            } else {
                                setErrorMessage(true);
                            }
                        }
                    case 26:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function handleWireTransferOrder() {
            return _ref.apply(this, arguments);
        };
    }();
    // Check if deposit is required
    var depositPercentage = payment_process.env.SWIKLY_DEPOSIT_PERCENTAGE ? parseFloat(payment_process.env.SWIKLY_DEPOSIT_PERCENTAGE) : 0;
    var isDepositRequired = depositPercentage > 0 && (cart === null || cart === void 0 ? void 0 : (ref3 = cart.item) === null || ref3 === void 0 ? void 0 : (ref4 = ref3.items) === null || ref4 === void 0 ? void 0 : ref4.some(function(item) {
        return item.type === 'RENTAL';
    }));
    var canProceedToPayment = (!isDepositRequired || depositCompleted) && !hasStockError;
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Layout/* default */.Z, {
        mainLogo: main === null || main === void 0 ? void 0 : (ref5 = main.data) === null || ref5 === void 0 ? void 0 : ref5.logo,
        doc: main,
        metaTitle: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref6 = doc.data) === null || ref6 === void 0 ? void 0 : ref6.meta_title_payment, t('texts:funnel:payement')),
        hideTop: true,
        t: t,
        inStoreText: inStoreText,
        metaDescription: doc === null || doc === void 0 ? void 0 : (ref7 = doc.data) === null || ref7 === void 0 ? void 0 : ref7.meta_description_payment,
        metaKeywords: doc === null || doc === void 0 ? void 0 : (ref8 = doc.data) === null || ref8 === void 0 ? void 0 : ref8.meta_keywords_payment,
        basket: basket,
        account: accountRes,
        faq: faqRes,
        banner: banner,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
            className: (0,clsx_m/* default */.Z)('payment', 'checkout', classes.root),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: (0,clsx_m/* default */.Z)('funnel', classes.funnel),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                    maxWidth: 'xl',
                    "data-testid": 'payment',
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                        className: classes.funnelLayout,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                className: classes.funnelContent,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(FunnelHeader/* default */.Z, {
                                        title: (doc === null || doc === void 0 ? void 0 : (ref9 = doc.data) === null || ref9 === void 0 ? void 0 : (ref10 = ref9.steps) === null || ref10 === void 0 ? void 0 : (ref11 = ref10[0]) === null || ref11 === void 0 ? void 0 : (ref12 = ref11['title']) === null || ref12 === void 0 ? void 0 : (ref13 = ref12[0]) === null || ref13 === void 0 ? void 0 : ref13.text) ? doc === null || doc === void 0 ? void 0 : (ref14 = doc.data) === null || ref14 === void 0 ? void 0 : (ref15 = ref14.steps) === null || ref15 === void 0 ? void 0 : (ref16 = ref15[0]) === null || ref16 === void 0 ? void 0 : (ref17 = ref16['title']) === null || ref17 === void 0 ? void 0 : (ref18 = ref17[0]) === null || ref18 === void 0 ? void 0 : ref18.text : t('texts:funnel:payment:title')
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(FunnelBox/* default */.Z, {
                                        steps: (0,utils_funnel/* getStepperSteps */.S8)(doc === null || doc === void 0 ? void 0 : (ref19 = doc.data) === null || ref19 === void 0 ? void 0 : ref19.steps, doc === null || doc === void 0 ? void 0 : (ref20 = doc.data) === null || ref20 === void 0 ? void 0 : ref20.order_reference_label, {
                                            informationSkipped: informationSkipped
                                        }),
                                        t: t,
                                        activeStep: (0,utils_funnel/* getFunnelStepIndex */.Lf)('payment', {
                                            informationSkipped: informationSkipped
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                                                href: (0,utils_funnel/* getPrevFunnelRoute */.pU)('payment'),
                                                passHref: true,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                                                    onClick: function() {
                                                        return trackEvent({
                                                            category: "Payment",
                                                            action: "Return to shipping"
                                                        });
                                                    },
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                        variant: 'body2',
                                                        className: classes.backLink,
                                                        component: "span",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(KeyboardBackspace/* default */.Z, {
                                                                className: classes.backArrow
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                    asText: true,
                                                                    data: doc === null || doc === void 0 ? void 0 : (ref21 = doc.data) === null || ref21 === void 0 ? void 0 : ref21.return_button,
                                                                    defaultText: t('texts:funnel:return_button')
                                                                })
                                                            })
                                                        ]
                                                    })
                                                })
                                            }),
                                            !byPassPayment && !canProceedToPayment && /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                className: classes.center,
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentForm_SwiklyCaution, {
                                                    cart: cart,
                                                    parameters: parameters,
                                                    onCautionComplete: function() {
                                                        return setDepositCompleted(true);
                                                    },
                                                    depositExplanation: funnel === null || funnel === void 0 ? void 0 : (ref22 = funnel.data) === null || ref22 === void 0 ? void 0 : ref22.swikly_deposit_infos,
                                                    cautionInfo: funnel === null || funnel === void 0 ? void 0 : (ref23 = funnel.data) === null || ref23 === void 0 ? void 0 : ref23.swikly_caution_info
                                                })
                                            }),
                                            !(doc === null || doc === void 0 ? void 0 : (ref24 = doc.data) === null || ref24 === void 0 ? void 0 : ref24.disable_coupon) && canProceedToPayment && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "payment-coupon ".concat(classes.center),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "h5",
                                                        component: "h2",
                                                        className: classes.promoTitle,
                                                        children: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref25 = doc.data) === null || ref25 === void 0 ? void 0 : ref25.coupon_title, t('texts:funnel:coupon_title'))
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                                                        container: true,
                                                        spacing: 2,
                                                        alignItems: 'center',
                                                        wrap: 'nowrap',
                                                        className: 'payment-coupon__grid',
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                item: true,
                                                                xs: "auto",
                                                                className: (0,clsx_m/* default */.Z)('payment-coupon__field', classes.promoField),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                                    type: "text",
                                                                    name: "promoCode",
                                                                    placeholder: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref26 = doc.data) === null || ref26 === void 0 ? void 0 : ref26.coupon_label, t('texts:funnel:coupon_label')),
                                                                    value: code,
                                                                    required: false,
                                                                    onChange: setCode
                                                                })
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                                item: true,
                                                                xs: "auto",
                                                                className: (0,clsx_m/* default */.Z)('payment-coupon__cta', classes.promoCTA),
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                    size: 'small',
                                                                    variant: 'contained',
                                                                    color: 'secondary',
                                                                    onClick: function() {
                                                                        return applyCoupon();
                                                                    },
                                                                    className: classes.btnCoupon,
                                                                    children: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref27 = doc.data) === null || ref27 === void 0 ? void 0 : ref27.coupon_cta, t('texts:funnel:coupon_cta'))
                                                                })
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: classes.alignCenter,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: classes.couponSentences,
                                                            children: [
                                                                (cart === null || cart === void 0 ? void 0 : (ref28 = cart.item) === null || ref28 === void 0 ? void 0 : ref28.couponCode) && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                                                                    variant: 'body2',
                                                                    color: 'secondary',
                                                                    className: 'promo__code',
                                                                    children: [
                                                                        (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref29 = doc.data) === null || ref29 === void 0 ? void 0 : ref29.coupon_applied, t('texts:funnel:coupon_applied')),
                                                                        ' ',
                                                                        cart === null || cart === void 0 ? void 0 : (ref30 = cart.item) === null || ref30 === void 0 ? void 0 : ref30.couponCode
                                                                    ]
                                                                }),
                                                                couponValid && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    variant: 'body2',
                                                                    color: 'secondary',
                                                                    className: 'promo__code',
                                                                    children: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref31 = doc.data) === null || ref31 === void 0 ? void 0 : ref31.coupon_success, t('texts:funnel:coupon_success'))
                                                                }),
                                                                couponRemoved && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    variant: 'body2',
                                                                    color: 'secondary',
                                                                    className: 'promo__code',
                                                                    children: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref32 = doc.data) === null || ref32 === void 0 ? void 0 : ref32.coupon_removed, t('texts:funnel:coupon_removed'))
                                                                }),
                                                                couponError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    variant: 'body2',
                                                                    color: 'error',
                                                                    children: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref33 = doc.data) === null || ref33 === void 0 ? void 0 : ref33.coupon_error, t('texts:funnel:coupon_error'))
                                                                })
                                                            ]
                                                        })
                                                    })
                                                ]
                                            }),
                                            !userBypassPayment && byPassPayment && !constants/* byPassPassword */.X9 && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "payment-code-operator ".concat(classes.center),
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                        variant: "h5",
                                                        component: "h2",
                                                        className: classes.codeOperatorTitle,
                                                        children: (0,CMSText/* prismicText */.yz)(funnel === null || funnel === void 0 ? void 0 : (ref34 = funnel.data) === null || ref34 === void 0 ? void 0 : ref34.code_operator_label, t('texts:funnel:payment:code_operator_label'))
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                        container: true,
                                                        spacing: 2,
                                                        alignItems: 'center',
                                                        wrap: 'nowrap',
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                            item: true,
                                                            xs: "auto",
                                                            className: classes.codeOperatorField,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TextField/* default */.Z, {
                                                                type: "text",
                                                                name: "codeOperator",
                                                                placeholder: (0,CMSText/* prismicText */.yz)(funnel === null || funnel === void 0 ? void 0 : (ref35 = funnel.data) === null || ref35 === void 0 ? void 0 : ref35.code_operator_placeholder, t('texts:funnel:payment:code_operator_placeholder')),
                                                                value: codeOperator,
                                                                required: true,
                                                                onChange: handleCodeOperatorValue
                                                            })
                                                        })
                                                    })
                                                ]
                                            }),
                                            byPassPayment && ((ref37 = funnel === null || funnel === void 0 ? void 0 : (ref36 = funnel.data) === null || ref36 === void 0 ? void 0 : ref36.cgu[0]) === null || ref37 === void 0 ? void 0 : (ref38 = ref37.text) === null || ref38 === void 0 ? void 0 : ref38.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(FormControlLabel/* default */.Z, {
                                                control: /*#__PURE__*/ (0,jsx_runtime.jsx)(Checkbox/* default */.Z, {
                                                    checked: byPassCgu,
                                                    onChange: changeByPassCgu
                                                }),
                                                label: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                    variant: 'body2',
                                                    component: 'span',
                                                    className: classes.cgu,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                        data: funnel === null || funnel === void 0 ? void 0 : (ref39 = funnel.data) === null || ref39 === void 0 ? void 0 : ref39.cgu,
                                                        defaultText: t('texts:funnel:payment:cgu')
                                                    })
                                                })
                                            }),
                                            canProceedToPayment && /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
                                                children: !byPassPayment ? /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                    className: "payment-bycard ".concat(classes.center),
                                                    children: [
                                                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "h5",
                                                            component: "h2",
                                                            children: (0,CMSText/* prismicText */.yz)(doc === null || doc === void 0 ? void 0 : (ref40 = doc.data) === null || ref40 === void 0 ? void 0 : ref40.titleform, t('texts:funnel:titleform'))
                                                        }),
                                                        isDepositRequired && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                            variant: "body1",
                                                            color: "textSecondary",
                                                            align: "center",
                                                            style: {
                                                                marginBottom: 16
                                                            },
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                                asText: true,
                                                                data: funnel === null || funnel === void 0 ? void 0 : (ref41 = funnel.data) === null || ref41 === void 0 ? void 0 : ref41.swikly_caution_info,
                                                                defaultText: t('texts:funnel:payment:caution_info')
                                                            })
                                                        }),
                                                        payment_process.env.NEXT_PUBLIC_CHECKOUT_KEY && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentForm_PaymentFormCheckout, {
                                                            publicKey: payment_process.env.NEXT_PUBLIC_CHECKOUT_KEY,
                                                            text: doc === null || doc === void 0 ? void 0 : doc.data,
                                                            t: t,
                                                            settings: main === null || main === void 0 ? void 0 : main.data,
                                                            coupon: couponValid ? code : '',
                                                            swikId: reference,
                                                            disabled: !canProceedToPayment
                                                        }),
                                                         true && !payment_process.env.PAYPAL_CLIENT_ID && stripePromise && (cart === null || cart === void 0 ? void 0 : (ref42 = cart.item) === null || ref42 === void 0 ? void 0 : ref42.startLeasingDate) && /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.Elements, {
                                                            stripe: stripePromise,
                                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentForm_PaymentFormStripe, {
                                                                text: doc === null || doc === void 0 ? void 0 : doc.data,
                                                                t: t,
                                                                startLeasingDate: cart && (cart === null || cart === void 0 ? void 0 : (ref43 = cart.item) === null || ref43 === void 0 ? void 0 : ref43.startLeasingDate),
                                                                coupon: couponValid ? code : '',
                                                                swikId: reference,
                                                                disabled: !canProceedToPayment
                                                            })
                                                        }),
                                                        payment_process.env.USE_ADYEN && !payment_process.env.PAYPAL_CLIENT_ID && (cart === null || cart === void 0 ? void 0 : (ref44 = cart.item) === null || ref44 === void 0 ? void 0 : ref44.startLeasingDate) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentForm_PaymentFormAdyen, {
                                                            text: doc === null || doc === void 0 ? void 0 : doc.data,
                                                            t: t,
                                                            startLeasingDate: cart && (cart === null || cart === void 0 ? void 0 : (ref45 = cart.item) === null || ref45 === void 0 ? void 0 : ref45.startLeasingDate),
                                                            coupon: couponValid ? code : '',
                                                            swikId: reference,
                                                            disabled: !canProceedToPayment
                                                        }),
                                                         true && payment_process.env.PAYPAL_CLIENT_ID && stripePromise && (cart === null || cart === void 0 ? void 0 : (ref46 = cart.item) === null || ref46 === void 0 ? void 0 : ref46.startLeasingDate) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentForm_PaymentAccordion, {
                                                            cardComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(react_stripe_umd.Elements, {
                                                                stripe: stripePromise,
                                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentForm_PaymentFormStripe, {
                                                                    text: doc === null || doc === void 0 ? void 0 : doc.data,
                                                                    t: t,
                                                                    startLeasingDate: cart && (cart === null || cart === void 0 ? void 0 : (ref47 = cart.item) === null || ref47 === void 0 ? void 0 : ref47.startLeasingDate),
                                                                    coupon: couponValid ? code : '',
                                                                    swikId: reference,
                                                                    disabled: !canProceedToPayment
                                                                })
                                                            }),
                                                            paypalComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentForm_PaymentPaypal, {
                                                                doc: doc,
                                                                startLeasingDate: cart && (cart === null || cart === void 0 ? void 0 : (ref48 = cart.item) === null || ref48 === void 0 ? void 0 : ref48.startLeasingDate),
                                                                coupon: couponValid ? code : '',
                                                                disabled: !canProceedToPayment
                                                            })
                                                        }),
                                                        payment_process.env.USE_ADYEN && payment_process.env.PAYPAL_CLIENT_ID && (cart === null || cart === void 0 ? void 0 : (ref49 = cart.item) === null || ref49 === void 0 ? void 0 : ref49.startLeasingDate) && /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentForm_PaymentAccordion, {
                                                            cardComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentForm_PaymentFormAdyen, {
                                                                text: doc === null || doc === void 0 ? void 0 : doc.data,
                                                                t: t,
                                                                startLeasingDate: cart && (cart === null || cart === void 0 ? void 0 : (ref50 = cart.item) === null || ref50 === void 0 ? void 0 : ref50.startLeasingDate),
                                                                coupon: couponValid ? code : '',
                                                                swikId: reference,
                                                                disabled: !canProceedToPayment
                                                            }),
                                                            paypalComponent: /*#__PURE__*/ (0,jsx_runtime.jsx)(PaymentForm_PaymentPaypal, {
                                                                doc: doc,
                                                                startLeasingDate: cart && (cart === null || cart === void 0 ? void 0 : (ref51 = cart.item) === null || ref51 === void 0 ? void 0 : ref51.startLeasingDate),
                                                                coupon: couponValid ? code : '',
                                                                disabled: !canProceedToPayment
                                                            })
                                                        }),
                                                        constants/* isWireTransferEnabled */.f8 && isLoggedIn && /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                            className: classes.alignCenter,
                                                            style: {
                                                                marginTop: 24
                                                            },
                                                            children: [
                                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                                    variant: "body2",
                                                                    color: "textSecondary",
                                                                    align: "center",
                                                                    style: {
                                                                        marginBottom: 8
                                                                    },
                                                                    children: t('texts:funnel:payment:wire_transfer_separator', 'Or')
                                                                }),
                                                                isLoader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                                    className: 'payment-form__wire-transfer',
                                                                    variant: "outlined",
                                                                    color: "primary",
                                                                    onClick: handleWireTransferOrder,
                                                                    type: "button",
                                                                    disabled: hasStockError,
                                                                    children: t('texts:funnel:payment:wire_transfer_button', 'Pay later with a wire transfer')
                                                                })
                                                            ]
                                                        })
                                                    ]
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                    className: classes === null || classes === void 0 ? void 0 : classes.alignCenter,
                                                    children: isLoader ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {}) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                                                        className: 'payment-form__submit',
                                                        variant: "contained",
                                                        "data-testid": "paymentSubmit",
                                                        color: "primary",
                                                        onClick: handleByPassOrder,
                                                        type: "submit",
                                                        disabled: hasStockError || (((ref53 = funnel === null || funnel === void 0 ? void 0 : (ref52 = funnel.data) === null || ref52 === void 0 ? void 0 : ref52.cgu[0]) === null || ref53 === void 0 ? void 0 : ref53.text.length) > 0 ? !byPassCgu : false),
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                            asText: true,
                                                            data: funnel === null || funnel === void 0 ? void 0 : (ref54 = funnel.data) === null || ref54 === void 0 ? void 0 : ref54.operator_button_validation,
                                                            defaultText: t('texts:funnel:payment:errors:operator_button_validation')
                                                        })
                                                    })
                                                })
                                            }),
                                            errorMessage && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                color: 'error',
                                                variant: 'body1',
                                                align: 'center',
                                                children: t('texts:funnel:payment:error')
                                            }),
                                            errorCodeOperator && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                color: 'error',
                                                variant: 'body1',
                                                align: 'center',
                                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(CMSText/* default */.ZP, {
                                                    data: funnel === null || funnel === void 0 ? void 0 : (ref55 = funnel.data) === null || ref55 === void 0 ? void 0 : ref55.wrong_code_operator,
                                                    defaultText: t('texts:funnel:payment:errors:wrong_code_operator')
                                                })
                                            }),
                                            minimumCartItemsError && /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                                color: 'error',
                                                variant: 'body1',
                                                align: 'center',
                                                children: t('texts:funnel:payment:errors:minimum_cart_items')
                                            }),
                                            (0,CMSText/* isPrismicText */.LT)(doc === null || doc === void 0 ? void 0 : (ref56 = doc.data) === null || ref56 === void 0 ? void 0 : ref56.data_text) && /*#__PURE__*/ (0,jsx_runtime.jsx)(TextBox/* default */.Z, {
                                                text: doc === null || doc === void 0 ? void 0 : (ref57 = doc.data) === null || ref57 === void 0 ? void 0 : ref57.data_text
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                container: true,
                                                spacing: 2,
                                                children: (doc === null || doc === void 0 ? void 0 : doc.data) ? doc === null || doc === void 0 ? void 0 : doc.data.commitment.map(function(commit, index) {
                                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                        item: true,
                                                        xs: 12,
                                                        md: 6,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Commitment/* default */.Z, {
                                                            center: true,
                                                            icon: commit.icon.url,
                                                            title: (0,CMSText/* prismicText */.yz)(commit === null || commit === void 0 ? void 0 : commit.title),
                                                            desc: (0,CMSText/* prismicText */.yz)(commit === null || commit === void 0 ? void 0 : commit.text)
                                                        })
                                                    }, index));
                                                }) : [
                                                    0,
                                                    1
                                                ].map(function(index) {
                                                    return(/*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                                                        item: true,
                                                        xs: 12,
                                                        md: 6,
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Commitment/* default */.Z, {
                                                            center: true,
                                                            icon: '/images/placeholder.jpg',
                                                            title: t('texts:general:add_a_title'),
                                                            desc: t('texts:general:add_a_description')
                                                        })
                                                    }, index));
                                                })
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: classes.funnelAside,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FunnelAside/* default */.Z, {
                                    text: funnel === null || funnel === void 0 ? void 0 : funnel.data,
                                    basket: basket,
                                    parameters: parameters,
                                    takeback: takeback,
                                    settings: main,
                                    deleteCoupon: clearCoupon
                                })
                            })
                        ]
                    })
                })
            })
        })
    }));
};
var __N_SSG = true;
/* harmony default export */ var payment = ((0,es/* connect */.$j)(payment_mapStateToProps, payment_mapDispatchToProps)(Payment));


/***/ }),

/***/ 38962:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "x": function() { return /* binding */ useStripePromise; }
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _stripe_stripe_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(54465);


var useStripePromise = function(isInstore) {
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(), stripePromise = ref[0], setStripePromise = ref[1];
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(function() {
        var stripeKey = "pk_live_olbIxvmYIq0FBB0JSQqNMjGS00jw5nnSzk";
        if (stripeKey) {
            if (true) {
                if (isInstore && JSON.parse(localStorage.getItem('selectedStore')).stripeConnectId && JSON.parse(localStorage.getItem('selectedStore')).stripeConnectId !== null) {
                    setStripePromise((0,_stripe_stripe_js__WEBPACK_IMPORTED_MODULE_1__/* .loadStripe */ .J)(stripeKey, {
                        stripeAccount: JSON.parse(localStorage.getItem('selectedStore')).stripeConnectId
                    }));
                } else {
                    setStripePromise((0,_stripe_stripe_js__WEBPACK_IMPORTED_MODULE_1__/* .loadStripe */ .J)(stripeKey, {
                        stripeAccount: "acct_1KbRilGouixuYJ68"
                    }));
                }
            } else {}
        }
    }, []);
    return stripePromise;
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [56909,282,2215,15350,79593,68480,1111,57443,94108,74805,9101,75840,230,19789,29705,79956,88346,49774,92888,40179], function() { return __webpack_exec__(49586); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);